var isLw100Personalization = false;
var isAs022Personalization = false;
var isPlaettchenPreviewPersonalization = false;
var isEngravingOnlyPopup = true;
(function($) {
  var CHAR_MAX_LINE1 = isAs022Personalization ? 12 : 10;
  var CHAR_MAX_LINE2 = 4;
  var SYMBOL_COST = 3;
  /* Vierte Gravur-Art (Yin 2026-08-18: „参考 A221"): Name oben, darunter ein
     Motiv. Kuerzer als die freie 1. Zeile, weil unter dem Namen noch das
     Motiv steht — Wert wie auf A221/LW100. */
  var LW041_TM_LAYOUT = 'text_oben_motiv_unten';
  var CHAR_MAX_TM_TEXT = 8;
  var ALLOWED_FONTS = ['G02', 'G04', 'G05', 'G06'];
  var AS022_ALLOWED_FONTS = ['G02', 'G03', 'G04', 'G05', 'G06', 'G07', 'G08'];
  var AS022_G07_ONLY_LAYOUT = '1_zeile';
  var AS022_G07_CHAR_MAX = 8;
  var SIDE_LABELS = ['Vorderseite', 'Rückseite'];
  var sideLayouts = ['1_zeile', '1_zeile'];
  var previewSideCount = 1;
  var physicalSideMap = [0];
  var globalFont = null;
  var fontsCache = null;
  var symbolsCache = null;

  function setPhysicalSideMap(map) {
    physicalSideMap = Array.isArray(map) && map.length ? map.slice() : [0];
  }

  function getPhysicalSideIndex(uiSideIndex) {
    if (physicalSideMap[uiSideIndex] != null) return physicalSideMap[uiSideIndex];
    return uiSideIndex;
  }

  window.lw041SetPhysicalSideMap = setPhysicalSideMap;

  var LW041_PREVIEW_IMAGES = {
    silver: window.VIV_LW041.bild_lw041_preview_silver_png,
    gold: window.VIV_LW041.bild_lw041_preview_gold_png,
    rosegold: window.VIV_LW041.bild_lw041_preview_rosegold_png,
    silverVorder: window.VIV_LW041.bild_lw041_preview_silver_vorder_png,
    goldVorder: window.VIV_LW041.bild_lw041_preview_gold_vorder_png,
    rosegoldVorder: window.VIV_LW041.bild_lw041_preview_rosegold_vorder_png
  };

  /* ---- Motive: W-Reihe (2026-08-07) --------------------------------------
     Loest die alte C-Reihe ab — Beschluss Yin: eine einzige Icon-Familie im
     ganzen Shop, Referenz ist KE008. Satz = KE008s zehn + Pfote (W31) = elf.

     ★ Der Bestand kommt jetzt aus DIESER Datei. Frueher wurde er aus dem
     Template-Picker (.product_info_image_json, die alten C1–C50) gefiltert —
     das Snippet hing also daran, dass im Template noch der alte Picker steckt.
     Diese Abhaengigkeit ist weg.

     ⚠️ Dateinamen sind unregelmaessig: w01–w10 zweistellig, ab W11
     dreistellig (w011, w027, w031 …). Nicht "vereinheitlichen". */
  var LW041_SYMBOL_NAMES = {
    'w01.png': 'Mini Herz', 'w02.png': 'Herz', 'w03.png': 'Doppelherz', 'w05.png': 'Infinity',
    'w06.png': 'Jesusfisch', 'w07.png': 'Kreuz', 'w09.png': 'Engel', 'w027.png': 'Anker',
    'w031.png': 'Pfote', 'w036.png': 'Fee', 'w041.png': 'Stern'
  };

  var LW041_SYMBOLS_FIXED = [
    { code: 'W01', text: 'Mini Herz',  image: window.VIV_LW041.bild_w01_png },
    { code: 'W02', text: 'Herz',       image: window.VIV_LW041.bild_w02_png },
    { code: 'W03', text: 'Doppelherz', image: window.VIV_LW041.bild_w03_png },
    { code: 'W05', text: 'Infinity',   image: window.VIV_LW041.bild_w05_png },
    { code: 'W06', text: 'Jesusfisch', image: window.VIV_LW041.bild_w06_png },
    { code: 'W07', text: 'Kreuz',      image: window.VIV_LW041.bild_w07_png },
    { code: 'W09', text: 'Engel',      image: window.VIV_LW041.bild_w09_png },
    { code: 'W27', text: 'Anker',      image: window.VIV_LW041.bild_w027_png },
    { code: 'W31', text: 'Pfote',      image: window.VIV_LW041.bild_w031_png },
    { code: 'W36', text: 'Fee',        image: window.VIV_LW041.bild_w036_png },
    { code: 'W41', text: 'Stern',      image: window.VIV_LW041.bild_w041_png }
  ];
  /* Altwerte: KH1–KH8 aus der ersten Generation, plus die eine echte
     Umbenennung beim Wechsel auf die W-Reihe (Fisch → Jesusfisch). Ohne den
     Alias faende getSymbolByName() ein altes "Fisch" nicht mehr und das Motiv
     fiele im wiederhergestellten Warenkorb stillschweigend weg. */
  var LW041_KH_LEGACY = {
    'KH1': 'Mini Herz', 'KH2': 'Herz', 'KH3': 'Doppelherz', 'KH4': 'Infinity',
    'KH5': 'Jesusfisch', 'KH6': 'Anker', 'KH7': 'Engel', 'KH8': 'Pfote',
    'Fisch': 'Jesusfisch', 'Christenfisch': 'Jesusfisch'
  };

  /* 1 ZEILE — container position; text/icon size via CSS --lw041-1zeile-* */
  var PREVIEW_1_ZEILE = {
    front: { top: 74, left: 25.5 },
    back: { top: 74, left: 75.5 }
  };
  var LW100_DUAL_1_ZEILE = {
    front: { top: 45, left: 25 },
    back: { top: 45, left: 75.5 }
  };
  var AS022_PLAETTCHEN_POS = {
    front: { top: 47, left: 25.8 },
    back: { top: 47, left: 74.5 }
  };
  var AS022_2ZEILEN_LINE2 = {
    front: { top: 53, left: 25.8 },
    back: { top: 53, left: 74.5 }
  };
  var AS022_NUR_MOTIV = {
    front: { top: 49, left: 25.8 },
    back: { top: 49, left: 74.5 }
  };
  var AS022_2ZEILEN_ROW_GAP_EXTRA = 1; /* +1% on base line1→line2 gap */
  var AS022_PREVIEW_TEXT_MAX_WIDTH_PCT = 24; /* 384px @ 1600 canvas */
  var PREVIEW_LETTER_ONLY_SCALE = 1.5; /* Phase 1①: letter_only only; not letter_icon */
  /* 2 ZEILEN — line1/line2 position; text/icon size via CSS --lw041-2zeilen-* */
  var PREVIEW_2_ZEILEN = {
    line1: {
      front: { top: 73, left: 25.5 },
      back: { top: 73, left: 75.5 }
    },
    line2: {
      front: { top: 76, left: 25.5 },
      back: { top: 76, left: 75.5 }
    }
  };
  var PREVIEW_TEXT_MAX_WIDTH_1600 = 350;
  /* ★ BREITENKAPPE — 2026-08-19, Yin: „没有宽度限制器".
     Die alte Kappe (350/1600 = 21.9 % der Buehne) stammt aus der
     Plaettchen-Familie, wo die runde Scheibe fast die halbe Buehne einnimmt.
     Der Engel ist viel schmaler: AUF DER HOEHE DER GRAVURZEILE misst er am
     echten Foto (Pillow, lw041-preview-silver.png) nur
        y=73 % -> 16.7 %   y=74 % -> 15.9 %   y=76 % -> 12.5 %   der Buehne.
     Die Kappe lag damit WEITER als der Anhaenger breit ist — sie griff zwar
     (scale 0.95 gemessen), aber erst jenseits des Silhouettenrands. Genau das
     sieht man auf Yins Bild.
     Beide Zahlen wohnen als Regler in TUNE (limitBreite, limitBreiteZeile2),
     damit sie ueber das Panel einstellbar und ueber bake.py backbar sind.
     Zeile 2 sitzt tiefer, wo der Rock schmaler wird — daher der eigene,
     am Foto gemessene Verjuengungsfaktor 12.5 %% / 16.0 %% = 0.78. */
  var PREVIEW_TEXT_MAX_WIDTH_AS022 = 384;

  function getPreviewTextMaxWidthBase() {
    return isAs022Personalization ? PREVIEW_TEXT_MAX_WIDTH_AS022 : PREVIEW_TEXT_MAX_WIDTH_1600;
  }
  /* Nur Motiv tab only — container position; text/icon size via CSS --lw041-nur-motiv-* */
  var PREVIEW_NUR_MOTIV = {
    front: { top: 75, left: 25.5 },
    back: { top: 75, left: 75.5 }
  };
  var LW041_1ZEILE_ICON_GAP_DEFAULT = '-0.1em';
  var LW041_2ZEILEN_ICON_GAP_DEFAULT = '-0.1em';
  var LW041_1ZEILE_ICON_GAP = {
    /* Gemessen 2026-08-07 (Alpha-bbox der PNGs, GOTCHAS 14): beim Wechsel auf
       die W-Reihe wuchs der leere Rand links bei Infinity und Jesusfisch um je
       11.4 % der Box (= 0.159em bei 1.1em Bildhoehe), bei Doppelherz um 2.9 %.
       Die Gap-Werte ziehen genau das wieder ab, damit der SICHTBARE Abstand
       bleibt wie vorher. Die uebrigen neun Motive aendern sich um <1 % und
       laufen weiter ueber den Default. */
    'Doppelherz': '0.06em',
    'Infinity': '-0.06em',
    'Jesusfisch': '-0.06em'
  };
  var LW041_2ZEILEN_ICON_GAP = {
    /* Gemessen 2026-08-07 (Alpha-bbox der PNGs, GOTCHAS 14): beim Wechsel auf
       die W-Reihe wuchs der leere Rand links bei Infinity und Jesusfisch um je
       11.4 % der Box (= 0.159em bei 1.1em Bildhoehe), bei Doppelherz um 2.9 %.
       Die Gap-Werte ziehen genau das wieder ab, damit der SICHTBARE Abstand
       bleibt wie vorher. Die uebrigen neun Motive aendern sich um <1 % und
       laufen weiter ueber den Default. */
    'Doppelherz': '0.06em',
    'Infinity': '-0.06em',
    'Jesusfisch': '-0.06em'
  };

  function esc(s) {
    return String(s || '').replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function imageFileFromUrl(url) {
    return String(url || '').split('/').pop().split('?')[0];
  }

  function normalizeSymbolName(text, imageUrl) {
    var file = imageFileFromUrl(imageUrl);
    if (LW041_SYMBOL_NAMES[file]) return LW041_SYMBOL_NAMES[file];
    if (LW041_KH_LEGACY[text]) return LW041_KH_LEGACY[text];
    return text;
  }

  function normalizeStoredSymbol(name) {
    return name ? (LW041_KH_LEGACY[name] || name) : '';
  }

  function symbolSlug(name) {
    return String(normalizeStoredSymbol(name) || name || '')
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');
  }

  function getLayoutIconGap(name, previewMode) {
    var key = normalizeStoredSymbol(name) || name;
    var map = previewMode === '2_zeilen' ? LW041_2ZEILEN_ICON_GAP : LW041_1ZEILE_ICON_GAP;
    var fallback = previewMode === '2_zeilen' ? LW041_2ZEILEN_ICON_GAP_DEFAULT : LW041_1ZEILE_ICON_GAP_DEFAULT;
    return Object.prototype.hasOwnProperty.call(map, key) ? map[key] : fallback;
  }

  /* Nur noch die eigene Liste — kein Umweg mehr ueber den Template-Picker. */
  function loadSymbols() {
    if (symbolsCache) return symbolsCache;
    symbolsCache = LW041_SYMBOLS_FIXED.slice();
    return symbolsCache;
  }

  /* Bestellwert = "Anzeigename | CODE" (z. B. "Jesusfisch | W06"). Der Code ist
     der einzige Weg, wie der Auftrags-Parser das Bild findet; der Name steht
     davor, damit die Werkstatt ihn ohne Tabelle liest. */
  function formatSymbolOrderValue(name) {
    var resolved = normalizeStoredSymbol(name);
    if (!resolved) return '';
    var symbols = loadSymbols();
    for (var i = 0; i < symbols.length; i++) {
      if (symbols[i].text === resolved) {
        return symbols[i].code ? (resolved + ' | ' + symbols[i].code) : resolved;
      }
    }
    return resolved;
  }

  /* ★ Der Feldname entscheidet, ob der Auftrags-Parser ueberhaupt ein Bild
     zeigt. Er kennt nur zwei Muster:
       • Label endet auf "Motiv"        → er loest den Code auf
       • Label endet auf "Text + Motiv" → er trennt "Text(Motiv)" selbst auf
     Ein Motiv, das (wie frueher) unter dem Label "Text" mitfaehrt, landet bei
     ihm als reiner Text und bleibt fuer immer bildlos. Deshalb wechselt das
     Label, sobald die Zeile ein Motiv enthaelt.
     withCode = true fuer die Bestellzeile, false fuer die Bestaetigung, die
     der Kunde sieht — dort waere "| W06" nur Rauschen. */
  function lineOrderRow(title, plainLabel, mixedLabel, text, symbol, withCode) {
    var t = String(text || '');
    var symName = normalizeStoredSymbol(symbol);
    if (!symName) return { name: title + ' ' + plainLabel, value: t };
    var symOut = withCode ? formatSymbolOrderValue(symName) : symName;
    return { name: title + ' ' + mixedLabel, value: t + '(' + symOut + ')' };
  }

  function loadFonts() {
    if (fontsCache) return fontsCache;
    fontsCache = [];
    $('.product_info_font_json').each(function() {
      try {
        var arr = JSON.parse($(this).html());
        for (var i = 0; i < arr.length; i++) {
          if (isAs022Personalization) {
            if (arr[i] && arr[i].font_name && AS022_ALLOWED_FONTS.indexOf(arr[i].font_name) !== -1) {
              fontsCache.push(arr[i]);
            }
          } else if (ALLOWED_FONTS.indexOf(arr[i].font_name) !== -1) {
            fontsCache.push(arr[i]);
          }
        }
      } catch (e) {}
    });
    if (!isAs022Personalization) {
      ALLOWED_FONTS.forEach(function(code) {
        if (!fontsCache.some(function(f) { return f.font_name === code; })) {
          fontsCache.push({ font_name: code, text: code, image: '' });
        }
      });
      fontsCache.sort(function(a, b) {
        return ALLOWED_FONTS.indexOf(a.font_name) - ALLOWED_FONTS.indexOf(b.font_name);
      });
    } else {
      fontsCache.sort(function(a, b) {
        return AS022_ALLOWED_FONTS.indexOf(a.font_name) - AS022_ALLOWED_FONTS.indexOf(b.font_name);
      });
    }
    return fontsCache;
  }

  function isAs022G07FontAllowed() {
    if (!isAs022Personalization) return true;
    var zu = getActiveSideCount();
    if (zu < 1) return true;
    for (var i = 0; i < zu; i++) {
      if (getSideLayout(i) !== AS022_G07_ONLY_LAYOUT) return false;
    }
    return true;
  }

  function getSelectableFonts() {
    var fonts = loadFonts();
    if (!isAs022Personalization || isAs022G07FontAllowed()) return fonts;
    return fonts.filter(function(f) { return f.font_name !== 'G07'; });
  }

  function ensureAs022GlobalFontForLayout() {
    if (!isAs022Personalization || isAs022G07FontAllowed()) return false;
    if ((getGlobalFont().font_name || '') !== 'G07') return false;
    var fonts = getSelectableFonts();
    globalFont = fonts.length ? fonts[0] : { font_name: 'G02', text: 'NirmalaS' };
    applyFontToInputs();
    return true;
  }

  function getGlobalFont() {
    if (!globalFont) {
      var fonts = loadFonts();
      globalFont = fonts.length ? fonts[0] : { font_name: 'G02', text: 'NirmalaS' };
    }
    return globalFont;
  }

  function getLineMaxLen(lineNum, sideIndex) {
    if (isAs022Personalization && (getGlobalFont().font_name || '') === 'G07' && String(lineNum) !== '2') {
      return AS022_G07_CHAR_MAX;
    }
    if (sideIndex != null && String(lineNum) !== '2' && getSideLayout(sideIndex) === LW041_TM_LAYOUT) {
      return CHAR_MAX_TM_TEXT;
    }
    return String(lineNum) === '2' ? CHAR_MAX_LINE2 : CHAR_MAX_LINE1;
  }

  /* „Zeilenartig" = die Lage kommt aus PREVIEW_2_ZEILEN (Zeile 1 oben,
     Zeile 2 darunter). Text-oben-Motiv-unten benutzt genau diese beiden
     Anker — deshalb faellt es hier mit hinein und braucht keine eigenen. */
  function isZeilenLikeMode(previewMode) {
    return previewMode === '2_zeilen' || previewMode === 'text_motiv';
  }

  var LW041_FONT_STACK = {
    G01: 'MingLiU-ExtB, serif',
    G02: 'NirmalaS, sans-serif',
    G03: '"Time New Man", serif',
    G04: '"Monotype Corsiva", sans-serif',
    G05: '"Bradley Hand ITC", sans-serif',
    G06: '"Murray Hill BT", sans-serif',
    G07: 'Chloe, sans-serif',
    G08: 'fatskinny, sans-serif'
  };

  function getFontFamilyCss() {
    var font = getGlobalFont();
    var code = font.font_name || 'G02';
    if (LW041_FONT_STACK[code]) return LW041_FONT_STACK[code];
    if (font.text) return font.text.indexOf(',') !== -1 ? font.text : font.text + ', sans-serif';
    return LW041_FONT_STACK.G02;
  }

  function getPreviewFontCodeClass() {
    var code = (getGlobalFont().font_name || 'G02').toLowerCase();
    return ' lw041-preview-font-' + code;
  }

  function isUppercaseOnlyFont() {
    return (getGlobalFont().font_name || 'G02') === 'G08';
  }

  function sanitizeUppercaseLetters(text) {
    return String(text || '').toUpperCase().replace(/[^A-ZÄÖÜẞ0-9.]/g, '');
  }

  function isValidSymbolToken(inner) {
    return !!getSymbolByName(normalizeStoredSymbol(inner)) || !!getSymbolByName(inner);
  }

  function countPreviewLetters(raw) {
    raw = String(raw || '');
    var total = 0, re = /\(([^)]+)\)/g, last = 0, match;
    while ((match = re.exec(raw)) !== null) {
      total += (match.index - last);
      if (!isValidSymbolToken(match[1])) total += match[0].length;
      last = re.lastIndex;
    }
    total += raw.length - last;
    return total;
  }

  function countPreviewIcons(raw) {
    var count = 0, re = /\(([^)]+)\)/g, match;
    raw = String(raw || '');
    while ((match = re.exec(raw)) !== null) {
      if (isValidSymbolToken(match[1])) count++;
    }
    return count;
  }

  function isAs022PreviewLetterOnly(raw, previewMode, symbolOnly, sideClass) {
    if (!isAs022Personalization) return false;
    if (symbolOnly || previewMode === 'nur_motiv') return false;
    if (previewMode !== '1_zeile') return false;
    if (sideClass.indexOf('--front') === -1) return false;
    return countPreviewLetters(raw) === 1 && countPreviewIcons(raw) === 0;
  }

  function getPreviewLetterOnlyClass(raw, previewMode, symbolOnly, sideClass) {
    return isAs022PreviewLetterOnly(raw, previewMode, symbolOnly, sideClass)
      ? ' lw041-preview-text--letter-only' : '';
  }

  function getPreviewLetterOnlyScaleMultiplier(el) {
    if (!el || !el.classList) return 1;
    if (el.classList.contains('lw041-preview-text--letter-only')) return PREVIEW_LETTER_ONLY_SCALE;
    return 1;
  }

  function normalizeG08RawLine(raw) {
    raw = String(raw || '');
    var result = '', re = /\(([^)]*)\)/g, last = 0, match;
    while ((match = re.exec(raw)) !== null) {
      result += sanitizeUppercaseLetters(raw.substring(last, match.index));
      var inner = match[1];
      if (isValidSymbolToken(inner)) {
        var sym = getSymbolByName(normalizeStoredSymbol(inner)) || getSymbolByName(inner);
        result += '(' + sym.text + ')';
      } else {
        result += sanitizeUppercaseLetters(inner);
      }
      last = re.lastIndex;
    }
    result += sanitizeUppercaseLetters(raw.substring(last));
    return result;
  }

  function trimToWeightedMax(str, maxLen) {
    var s = String(str || '');
    while (weightedLength(s) > maxLen && s.length) s = s.slice(0, -1);
    return s.replace(/\([^)]*$/, '');
  }

  function lineHasSymbolAndText(raw) {
    if (!raw) return false;
    var hasSym = false, hasText = false;
    var re = /\(([^)]+)\)/g, last = 0, match;
    while ((match = re.exec(raw)) !== null) {
      if (!isValidSymbolToken(match[1])) continue;
      hasSym = true;
      if (sanitizeUppercaseLetters(raw.substring(last, match.index))) hasText = true;
      last = re.lastIndex;
    }
    if (sanitizeUppercaseLetters(raw.substring(last))) hasText = true;
    return hasSym && hasText;
  }

  function hasInlineSymbolTokens(raw) {
    if (!raw) return false;
    var re = /\(([^)]+)\)/g, match;
    while ((match = re.exec(raw)) !== null) {
      if (!isValidSymbolToken(match[1])) continue;
      if (match.index + match[0].length < raw.length) return true;
    }
    return false;
  }

  function getG08LineRaw($input, sideIndex, lineNum) {
    var raw = normalizeG08RawLine($input.val() || '');
    var storedSym = getLineSymbol(sideIndex, lineNum);
    if (storedSym && !/\([^)]+\)/.test(raw)) raw = composeLine(raw, storedSym);
    return raw;
  }

  function appendOrReplaceTrailingG08Symbol(raw, symName) {
    raw = normalizeG08RawLine(raw || '');
    var token = '(' + normalizeStoredSymbol(symName) + ')';
    var trailing = raw.match(/\(([^)]+)\)$/);
    if (trailing && isValidSymbolToken(trailing[1])) {
      return raw.slice(0, raw.length - trailing[0].length) + token;
    }
    return raw + token;
  }

  function setG08LineRaw($input, sideIndex, lineNum, raw, maxLen) {
    setLineSymbol(sideIndex, lineNum, '');
    raw = trimToWeightedMax(normalizeG08RawLine(raw), maxLen);
    $input.val(raw);
    toggleLineClear($input, raw);
    return raw;
  }

  function normalizeLineTextForFont(text) {
    if (!isUppercaseOnlyFont()) return text || '';
    return sanitizeUppercaseLetters(text);
  }

  function applyFontToInputs() {
    var fontCode = getGlobalFont().font_name || 'G02';
    var fontCss = getFontFamilyCss();
    $('.up-Fenster-p-personalization-1 .lw041-line-input')
      .attr('data-lw041-font', fontCode)
      .css('font-family', fontCss);
  }

  function weightedLength(str) {
    if (!str) return 0;
    var total = 0, re = /\(([^)]+)\)/g, last = 0, match;
    while ((match = re.exec(str)) !== null) {
      total += match.index - last;
      total += SYMBOL_COST;
      last = re.lastIndex;
    }
    total += str.length - last;
    return total;
  }

  function composeLine(text, symbol) {
    return (text || '') + (symbol ? '(' + normalizeStoredSymbol(symbol) + ')' : '');
  }

  function isSymbolOnlyRaw(raw) {
    if (!raw) return false;
    if (isUppercaseOnlyFont()) {
      var normalized = normalizeG08RawLine(raw);
      var only = normalized.match(/^\(([^)]+)\)$/);
      return !!(only && isValidSymbolToken(only[1]));
    }
    var parsed = parseLineValue(raw);
    return !!parsed.symbol && !parsed.text;
  }

  function parseLineValue(raw) {
    var val = raw || '';
    var match = val.match(/\(([^)]+)\)$/);
    if (match) {
      var symName = normalizeStoredSymbol(match[1]);
      if (getSymbolByName(symName) || getSymbolByName(match[1])) {
        return { text: val.substring(0, val.length - match[0].length), symbol: symName };
      }
    }
    return { text: val, symbol: '' };
  }

  function getSymbolByName(name) {
    if (!name) return null;
    var resolved = normalizeStoredSymbol(name);
    var symbols = loadSymbols();
    for (var i = 0; i < symbols.length; i++) {
      if (symbols[i].text === resolved || symbols[i].text === name) return symbols[i];
    }
    return null;
  }

  function getSideIndexFromEl($el) {
    var $side = $el.closest('[class*="product_info_main_"]');
    if (!$side.length) return NaN;
    var match = String($side.attr('class') || '').match(/product_info_main_(\d+)/);
    return match ? parseInt(match[1], 10) : NaN;
  }

  function getSideLabel(index) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + index);
    var title = $.trim($side.find('.pattles-message-header span').first().text());
    return title || SIDE_LABELS[index] || ('Seite ' + (index + 1));
  }

  function getActiveSideCount() {
    var domCount = $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]').length;
    return domCount > 0 ? domCount : previewSideCount;
  }

  function getColorKeyFromOption1() {
    var label = ($('[name="option1"]').attr('data-value') || '').toLowerCase();
    if (label.indexOf('ros') !== -1) return 'rosegold';
    if (label.indexOf('gold') !== -1 && label.indexOf('ros') === -1) return 'gold';
    return 'silver';
  }

  function getActiveGravurConfig() {
    return window.lw100GravurConfig || window.lw041GravurConfig || window.lwGravurConfig || null;
  }

  function ensureLw041GravurConfig() {
    if (getActiveGravurConfig() || typeof window.lwGravurResolveOption2 !== 'function') {
      return;
    }
    var config = window.lwGravurResolveOption2($('[name="option2"]').attr('data-value') || '');
    if (!config) return;
    window.lwGravurConfig = config;
    window.lw041GravurConfig = config;
  }

  function usesFrontOnlyPreviewBase() {
    ensureLw041GravurConfig();
    var sides = getActiveGravurConfig() && getActiveGravurConfig().physicalSides;
    return Array.isArray(sides) && sides.length === 1 && sides[0] === 0;
  }

  function getColorPreviewUrl() {
    var colorKey = getColorKeyFromOption1();
    if (usesFrontOnlyPreviewBase()) {
      return LW041_PREVIEW_IMAGES[colorKey + 'Vorder']
        || LW041_PREVIEW_IMAGES[colorKey]
        || LW041_PREVIEW_IMAGES.silverVorder
        || LW041_PREVIEW_IMAGES.silver;
    }
    return LW041_PREVIEW_IMAGES[colorKey] || LW041_PREVIEW_IMAGES.silver;
  }

  function getSideLayout(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    return $side.attr('data-lw041-layout') || sideLayouts[sideIndex] || '1_zeile';
  }

  function getLineSymbol(sideIndex, lineNum) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    return normalizeStoredSymbol($side.attr('data-lw041-symbol-line' + lineNum) || '');
  }

  function setLineSymbol(sideIndex, lineNum, sym) {
    $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex)
      .attr('data-lw041-symbol-line' + lineNum, normalizeStoredSymbol(sym || ''));
  }

  function getLineInputVal(sideIndex, lineNum) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    var $input = $side.find('.lw041-line-input[data-line="' + lineNum + '"]');
    return $input.length ? ($input.val() || '') : '';
  }

  function getLineParts(sideIndex, lineNum) {
    var raw = getLineInputVal(sideIndex, lineNum);
    if (isUppercaseOnlyFont()) {
      raw = normalizeG08RawLine(raw);
      var storedSym = getLineSymbol(sideIndex, lineNum);
      if (storedSym && !/\([^)]+\)/.test(raw)) raw = composeLine(raw, storedSym);
      return { text: raw, symbol: '' };
    }
    var parsed = parseLineValue(raw);
    var symbol = parsed.symbol || getLineSymbol(sideIndex, lineNum);
    return { text: parsed.text, symbol: symbol };
  }

  function toggleLineClear($input, value) {
    var hasContent = !!(value && String(value).trim());
    $input.siblings('.lw041-line-clear').css('display', hasContent ? 'block' : 'none');
  }

  function syncLineInputComposed($input, text, symbol) {
    var composed = composeLine(text, symbol);
    $input.val(composed);
    toggleLineClear($input, composed);
    return composed;
  }

  function getSideData(sideIndex) {
    var layout = getSideLayout(sideIndex);
    var data = { layout: layout, line1: '', line2: '', sym1: '', sym2: '', symOnly: '' };

    if (layout === '1_zeile') {
      var p1 = getLineParts(sideIndex, 1);
      data.line1 = p1.text;
      data.sym1 = p1.symbol;
    } else if (layout === '2_zeilen') {
      var p1b = getLineParts(sideIndex, 1);
      var p2 = getLineParts(sideIndex, 2);
      data.line1 = p1b.text;
      data.line2 = p2.text;
      data.sym1 = p1b.symbol;
      data.sym2 = p2.symbol;
    } else if (layout === 'nur_motiv') {
      var pMotiv = getLineParts(sideIndex, 1);
      data.symOnly = pMotiv.symbol || getLineSymbol(sideIndex, 1);
    } else if (layout === LW041_TM_LAYOUT) {
      // Text steht im Feld der 1. Zeile, das Motiv liegt im Symbolspeicher der
      // 2. Zeile — so kollidiert es nicht mit einer im Text getippten
      // Motiv-Marke.
      data.line1 = getLineParts(sideIndex, 1).text;
      data.sym2 = getLineSymbol(sideIndex, 2);
    }
    return data;
  }

  function sideHasContent(sideIndex) {
    var d = getSideData(sideIndex);
    if (d.layout === 'nur_motiv') return !!d.symOnly;
    if (d.layout === LW041_TM_LAYOUT) return !!(d.line1 || d.sym2);
    if (d.layout === '2_zeilen') {
      return !!(composeLine(d.line1, d.sym1) || composeLine(d.line2, d.sym2));
    }
    return !!composeLine(d.line1, d.sym1);
  }

  function sideHasText(d) {
    if (d.layout === 'nur_motiv') return false;
    if (d.layout === '2_zeilen') return !!(d.line1 || d.line2);
    return !!d.line1;
  }

  function getPreviewMode(d) {
    if (d.layout === 'nur_motiv') return 'nur_motiv';
    if (d.layout === LW041_TM_LAYOUT) return 'text_motiv';
    if (d.layout === '2_zeilen') return '2_zeilen';
    return '1_zeile';
  }

  function getLw100SinglePos() {
    if (isAs022Personalization) return AS022_PLAETTCHEN_POS.front;
    return { top: 45, left: 25 };
  }

  function getLw100DualPos(sideIndex) {
    if (isAs022Personalization) {
      var as022Pos = sideIndex === 1 ? AS022_PLAETTCHEN_POS.back : AS022_PLAETTCHEN_POS.front;
      return { top: as022Pos.top, left: as022Pos.left };
    }
    var pos = sideIndex === 1 ? LW100_DUAL_1_ZEILE.back : LW100_DUAL_1_ZEILE.front;
    return { top: pos.top, left: pos.left };
  }

  function getAs0222ZeilenLine1Pos(sideIndex) {
    if (usesFrontOnlyPreviewBase()) return AS022_PLAETTCHEN_POS.front;
    return sideIndex === 1 ? AS022_PLAETTCHEN_POS.back : AS022_PLAETTCHEN_POS.front;
  }

  function getAs0222ZeilenLine2Pos(sideIndex) {
    var pos = sideIndex === 1 ? AS022_2ZEILEN_LINE2.back : AS022_2ZEILEN_LINE2.front;
    return { top: pos.top, left: pos.left };
  }

  function getPreviewPos(sideIndex, previewMode, lineNum) {
    if (isPlaettchenPreviewPersonalization) {
      if (isZeilenLikeMode(previewMode) && lineNum === 2) {
        if (isAs022Personalization) {
          return getAs0222ZeilenLine2Pos(sideIndex);
        }
        if (usesFrontOnlyPreviewBase()) {
          return { top: 50, left: 25 };
        }
        var dualLine2Pos = getLw100DualPos(sideIndex);
        return { top: 50, left: dualLine2Pos.left };
      }
      if (previewMode === 'nur_motiv') {
        if (usesFrontOnlyPreviewBase()) {
          if (isAs022Personalization) return AS022_NUR_MOTIV.front;
          return PREVIEW_NUR_MOTIV.front;
        }
        if (isAs022Personalization) {
          var as022Nm = sideIndex === 1 ? AS022_NUR_MOTIV.back : AS022_NUR_MOTIV.front;
          return { top: as022Nm.top, left: as022Nm.left };
        }
        var nm = sideIndex === 1 ? PREVIEW_NUR_MOTIV.back : PREVIEW_NUR_MOTIV.front;
        return { top: nm.top, left: nm.left };
      }
      if (usesFrontOnlyPreviewBase()) {
        return getLw100SinglePos();
      }
      return getLw100DualPos(sideIndex);
    }
    if (previewMode === 'nur_motiv') {
      if (isAs022Personalization) {
        var as022Npos = sideIndex === 1 ? AS022_NUR_MOTIV.back : AS022_NUR_MOTIV.front;
        return { top: as022Npos.top, left: as022Npos.left };
      }
      var npos = sideIndex === 1 ? PREVIEW_NUR_MOTIV.back : PREVIEW_NUR_MOTIV.front;
      return { top: npos.top, left: npos.left };
    }
    if (isZeilenLikeMode(previewMode)) {
      var lcfg = lineNum === 2 ? PREVIEW_2_ZEILEN.line2 : PREVIEW_2_ZEILEN.line1;
      var lpos = sideIndex === 1 ? lcfg.back : lcfg.front;
      return { top: lpos.top, left: lpos.left };
    }
    var pos = sideIndex === 1 ? PREVIEW_1_ZEILE.back : PREVIEW_1_ZEILE.front;
    return { top: pos.top, left: pos.left };
  }


  /* Reglerfenster ?lw041tuner=1 — siehe docs/TUNER-VOLLAUSBAU.md.
     Alles neutral (0 bzw. 1): der Einbau veraendert kein bestehendes
     Vorschaubild. Position laeuft durch buildPreviewStyle(), Groesse
     ueber CSS-Faktoren an der Buehne — beides genau eine Stelle, der
     Gesamt-Layer kann also keinen Renderpunkt verfehlen.
     zeile2 ist eigenstaendig: die zweite Gravurzeile sitzt sonst starr
     an der ersten und liesse sich nie fuer sich ausrichten. */
  var LW041_TUNE = {
    blockDx: 0, blockDy: 0, blockScale: 1,
    motivScale: 1,
    /* LB — harte Breitenkappe in % der Buehne (Vorgabe = gemessene
       Anhaengerbreite 16.0 % minus Rand, damit die Gravur die Silhouette
       nicht beruehrt). */
    limitBreite: 14,
    /* LB — Zeile 2 sitzt tiefer, wo der Anhaenger schmaler wird.
       Vorgabe = gemessene Verjuengung (12.5 % / 16.0 %). */
    limitBreiteZeile2: 0.78,
    /* G1 — alle Motive gemeinsam verschieben, additiv ueber ICON_ADJ.
       Zwei-Schichten-Modell: Einzelwerte bleiben stehen. */
    motivDx: 0, motivDy: 0,
    zeile2: { dx: 0, dy: 0 },
    /* D2 — je Schriftart Lage und Groesse. Jede Schrift baut anders hoch;
       ein gemeinsamer Wert kann nie fuer alle passen. */
    schrift: {
      G02: { dx: 0, dy: 0, scale: 1 },
      G04: { dx: 0, dy: 0, scale: 1 },
      G05: { dx: 0, dy: 0, scale: 1 },
      G06: { dx: 0, dy: 0, scale: 1 }
    }
  };

  var LW041_ICON_ADJ = {};   /* D1: [seite][modus][slug] = { dx, dy, scale } */
  var LW041_LUFT_ADJ = {};   /* D3: [fontCode][slug] = em auf den Basisabstand */

  function lw041Pfad(wurzel, k1, k2) {
    if (!wurzel[k1]) wurzel[k1] = {};
    if (!wurzel[k1][k2]) wurzel[k1][k2] = {};
    return wurzel[k1][k2];
  }

  /* D3 — Abstand Schrift x Motiv: Grundwert aus dem Layout, Zuschlag je
     [Schrift][Motiv]. Ein breites Motiv braucht neben derselben Schrift
     einen anderen Abstand als ein schmales. */
  function lw041IconLuft(name, previewMode, fontCode) {
    var basis = getLayoutIconGap(name, previewMode);
    var zuschlag = ((LW041_LUFT_ADJ[fontCode] || {})[symbolSlug(name)]) || 0;
    if (!zuschlag) return basis;
    return ((parseFloat(basis) || 0) + zuschlag) + 'em';
  }

  function istSchriftEbene(previewMode, lineNum, raw) {
    if (raw == null) return false;
    if (previewMode === 'nur_motiv') return false;
    if (previewMode === 'text_motiv' && lineNum === 2) return false;
    if (!String(raw)) return false;
    return !isSymbolOnlyRaw(raw);
  }

  function getSchriftNudge(previewMode, lineNum, raw) {
    if (!istSchriftEbene(previewMode, lineNum, raw)) return { dx: 0, dy: 0 };
    return LW041_TUNE.schrift[getGlobalFont().font_name || 'G02'] || { dx: 0, dy: 0 };
  }
  /* KOMBI JE SCHRIFTART (Regel 7, Yin 2026-08-18; Vorbild KE030_KOMBI_BY_FONT).
     „Text oben, Motiv unten" sitzt fest auf den 2-Zeilen-Ankern; jede Schrift
     baut aber anders breit und hoch — Motiv-Lage/-Groesse und der Abstand
     Text<->Motiv muessen deshalb JE SCHRIFT verstellbar sein. Einheiten wie im
     eigenen Renderpfad: motivDx/motivDy/gap in % der Buehne, motivMult als
     Faktor auf die feste Motivhoehe (--lw041-icon-fixed-mixed). Leer =
     neutral: buildPreviewStyle liefert dann byte-gleiche Styles. Die Tabelle
     waechst erst beim Kalibrieren; scripts/lw041/bake.py setzt sie als
     GANZES Literal neu. Die Gesamt-Schicht (LW041_TUNE) bleibt eine Ebene
     DARUEBER, kein Ersatz. */
  var LW041_KOMBI_BY_FONT = {
    text_oben_motiv_unten: {
      G02: {
        textDx: 0,
        textDy: 0.5,
        motivDx: 0,
        motivDy: 1.75,
        motivMult: 1.1,
        gap: 0
      },
      G04: {
        textDx: 0,
        textDy: 1,
        motivDx: 0.5,
        motivDy: 2.25,
        motivMult: 1,
        gap: 0
      },
      G05: {
        textDx: 0,
        textDy: 0.5,
        motivDx: 0.5,
        motivDy: 1.75,
        motivMult: 1,
        gap: 0
      },
      G06: {
        textDx: 0,
        textDy: 0,
        motivDx: 0.5,
        motivDy: 2.5,
        motivMult: 1,
        gap: 0
      }
    }
  };
  var LW041_KOMBI_NEUTRAL = { textDx: 0, textDy: 0, motivDx: 0, motivDy: 0, motivMult: 1, gap: 0 };
  function lw041Kombi(layoutKey, fontName) {
    var tabelle = LW041_KOMBI_BY_FONT[layoutKey];
    if (!tabelle) return LW041_KOMBI_NEUTRAL;
    return tabelle[fontName] || LW041_KOMBI_NEUTRAL;
  }
  function lw041KombiSetzen(layoutKey, fontName) {
    var tabelle = LW041_KOMBI_BY_FONT[layoutKey];
    if (!tabelle) return LW041_KOMBI_NEUTRAL;   // Layout ohne Kombi-Regler
    if (!tabelle[fontName]) tabelle[fontName] = { textDx: 0, textDy: 0, motivDx: 0, motivDy: 0, motivMult: 1, gap: 0 };
    return tabelle[fontName];
  }
  function buildPreviewStyle(sideIndex, previewMode, lineNum, raw) {
    var pos = getPreviewPos(sideIndex, previewMode, lineNum);
    // Gesamt-Layer additiv auf die berechnete Lage; Zeile 2 zusaetzlich
    // eigenstaendig, damit sie sich unabhaengig ausrichten laesst.
    var t = LW041_TUNE;
    var z2 = (lineNum === 2) ? t.zeile2 : { dx: 0, dy: 0 };
    // Kombi je Schrift (nur „Text oben, Motiv unten"): gap schiebt Text und
    // Motiv symmetrisch auseinander (KE030-Semantik), Dx/Dy/Mult treffen nur
    // die Motiv-Ebene (Zeile 2).
    var kDx = 0, kDy = 0, kMult = '';
    if (previewMode === 'text_motiv') {
      var kombi = lw041Kombi(LW041_TM_LAYOUT, getGlobalFont().font_name || 'G02');
      if (lineNum === 2) {
        kDx = kombi.motivDx || 0;
        kDy = (kombi.motivDy || 0) + (kombi.gap || 0) / 2;
        if (kombi.motivMult != null && kombi.motivMult !== 1) {
          kMult = '--lw041-kombi-motiv-mult:' + kombi.motivMult + ';';
        }
      } else {
        /* K1 — der Text bekommt eine eigene Feinlage. gap schiebt weiter
           symmetrisch, textDx/textDy legen sich additiv darueber; sonst
           liesse sich nur das Motiv einzeln stellen (K2 ohne K1). */
        kDx = kombi.textDx || 0;
        kDy = -(kombi.gap || 0) / 2 + (kombi.textDy || 0);
      }
    }
    var sn = getSchriftNudge(previewMode, lineNum, raw);   /* D2 */
    if (sn.scale != null && sn.scale !== 1) kMult += 'scale:' + sn.scale + ';';
    return 'top:' + (pos.top + t.blockDy + z2.dy + kDy + sn.dy) + '%;left:' + (pos.left + t.blockDx + z2.dx + kDx + sn.dx) + '%;font-family:' + getFontFamilyCss() + ';' + kMult;
  }

  function getPreviewFontClass() {
    var code = getGlobalFont().font_name;
    if (code === 'G04') return ' lw041-preview-text--font-g04';
    if (code === 'G05') return ' lw041-preview-text--font-g05';
    if (code === 'G06') return ' lw041-preview-text--font-g06';
    if (code === 'G07' && isAs022Personalization) return ' lw041-preview-text--font-g07';
    if (code === 'G08' && isAs022Personalization) return ' lw041-preview-text--font-g08';
    return '';
  }

  function isAs022G08MixedLine(raw, previewMode, symbolOnly) {
    if (!isAs022Personalization || previewMode === 'nur_motiv' || symbolOnly) return false;
    if ((getGlobalFont().font_name || 'G02') !== 'G08') return false;
    return lineHasSymbolAndText(raw);
  }

  function isAs022G08SandwichIcon(previewMode, inlineBetween) {
    return isAs022Personalization
      && isUppercaseOnlyFont()
      && previewMode !== 'nur_motiv'
      && (previewMode === '1_zeile' || previewMode === '2_zeilen')
      && inlineBetween;
  }

  function isAs022G03MiniHerzBetween(previewMode, inlineBetween, symText) {
    return isAs022Personalization
      && (getGlobalFont().font_name || 'G02') === 'G03'
      && (previewMode === '1_zeile' || previewMode === '2_zeilen')
      && inlineBetween
      && symbolSlug(symText) === 'mini-herz';
  }

  function getAs022G08MixedFontClass(raw, previewMode, symbolOnly) {
    return isAs022G08MixedLine(raw, previewMode, symbolOnly) ? ' lw041-preview-text--font-g08-mixed' : '';
  }

  function getPreviewTextMaxWidthPx() {
    var stage = $('[data-lw041-preview-stage]')[0];
    if (isAs022Personalization) {
      if (stage && stage.clientWidth) {
        return stage.clientWidth * (AS022_PREVIEW_TEXT_MAX_WIDTH_PCT / 100);
      }
      return PREVIEW_TEXT_MAX_WIDTH_AS022;
    }
    var maxBase = getPreviewTextMaxWidthBase();
    if (!stage || !stage.clientWidth) return maxBase;
    var pct = LW041_TUNE.limitBreite;
    if (pct == null || !(pct > 0)) return stage.clientWidth * (maxBase / 1600);
    return stage.clientWidth * (pct / 100);
  }

  function fitPreviewTextWidths() {
    var maxWBasis = getPreviewTextMaxWidthPx();
    /* Gilt fuer 1 Zeile, 2 Zeilen UND „Text oben, Motiv unten" — dessen
       Textebene traegt die Klasse --2-zeilen und ist damit erfasst (Yin
       2026-08-19: „在一行 两行 和 文字加图标 都要有"). */
    $('[data-lw041-preview-stage] .lw041-preview-text--1-zeile, [data-lw041-preview-stage] .lw041-preview-text--2-zeilen').each(function() {
      var el = this;
      var maxW = el.getAttribute('data-lw041-preview-line') === '2'
        ? maxWBasis * LW041_TUNE.limitBreiteZeile2
        : maxWBasis;
      var contentScale = getPreviewLetterOnlyScaleMultiplier(el);
      el.style.transform = 'translate(-50%, -50%)';
      var w = el.scrollWidth;
      var finalScale = contentScale;
      if (w > 0 && maxW > 0 && w * finalScale > maxW) {
        finalScale = maxW / w;
      }
      if (finalScale !== 1) {
        el.style.transform = 'translate(-50%, -50%) scale(' + finalScale + ')';
      }
    });
  }

  function scheduleFitPreviewTextWidths() {
    requestAnimationFrame(function() {
      fitPreviewTextWidths();
      requestAnimationFrame(fitPreviewTextWidths);
    });
  }

  function getPreviewModeClass(previewMode, lineNum) {
    if (previewMode === 'nur_motiv') return ' lw041-preview-text--nur-motiv';
    // TEXT OBEN, MOTIV UNTEN: die Textzeile erbt die 2-Zeilen-Groessenregeln,
    // die Motivzeile bekommt bewusst KEINE davon — sonst gewaennen deren
    // Bildhoehen-Selektoren gegen die eigene Motivhoehe.
    if (previewMode === 'text_motiv') {
      return lineNum === 2 ? ' lw041-preview-text--tm-motiv' : ' lw041-preview-text--2-zeilen';
    }
    if (previewMode === '2_zeilen') return ' lw041-preview-text--2-zeilen';
    return ' lw041-preview-text--1-zeile';
  }

  function getLw100G02ZeilenSizeMultiplier(weightedLen) {
    var len = Math.max(0, Number(weightedLen) || 0);
    var maxLen = isAs022Personalization ? 12 : 10;
    if (len <= 1) return 1.35;
    if (len >= maxLen) return 0.85;
    if (len <= 3) {
      return 1.35 + ((len - 1) / 2) * (1.0 - 1.35);
    }
    return 1.0 + ((len - 3) / (maxLen - 3)) * (0.85 - 1.0);
  }

  function appendLw100G02ZeilenFontStyle(style, raw, previewMode) {
    if (!isPlaettchenPreviewPersonalization || previewMode !== '2_zeilen') return style;
    if ((getGlobalFont().font_name || 'G02') !== 'G02') return style;
    var mult = getLw100G02ZeilenSizeMultiplier(weightedLength(raw || ''));
    return style + 'font-size:calc(var(--lw041-2zeilen-text-size) * ' + mult + ');';
  }

  function getLw100G02ZeilenDynamicClass(raw, previewMode) {
    if (!isPlaettchenPreviewPersonalization || previewMode !== '2_zeilen') return '';
    if ((getGlobalFont().font_name || 'G02') !== 'G02') return '';
    if (!raw) return '';
    return ' lw100-g02-zeilen-dynamic';
  }

  function getLw100Dual1ZeileClass(sideClass, previewMode) {
    if (!isPlaettchenPreviewPersonalization || usesFrontOnlyPreviewBase() || previewMode !== '1_zeile') {
      return '';
    }
    if (sideClass.indexOf('--front') !== -1) return ' lw100-dual-front-1zeile';
    if (sideClass.indexOf('--back') !== -1) return ' lw100-dual-back-1zeile';
    return '';
  }

  /* ★ Der Stil MUSS durch esc(): die Schriftstapel G04/G05/G06 enthalten
     doppelte Anfuehrungszeichen ("Monotype Corsiva"). Roh in style="…"
     gesetzt beenden sie das Attribut mitten im Wert — font-family und alles
     danach fiel weg. Gefunden von der Zweigpruefung: „Text-Größe (Font)" war
     fuer genau diese drei Schriften ein toter Regler, G02 (Stapel ohne
     Anfuehrungszeichen) lief einwandfrei. Unsichtbar bis dahin, weil die
     CSS-Klasse .lw041-preview-text--font-g04 die Schrift ohnehin setzt. */
  function appendPreviewLine($layers, sideClass, style, raw, previewMode, lineNum) {
    if (!raw) return;
    var modeClass = getPreviewModeClass(previewMode, lineNum);
    var symbolOnly = previewMode !== 'nur_motiv' && isSymbolOnlyRaw(raw);
    var fontBoostClass = previewMode === 'nur_motiv' || symbolOnly ? '' : getPreviewFontClass();
    var symbolOnlyClass = symbolOnly ? ' lw041-preview-symbol-only' : '';
    var g08MixedFontClass = getAs022G08MixedFontClass(raw, previewMode, symbolOnly);
    var g08MixedTextScale = isAs022G08MixedLine(raw, previewMode, symbolOnly);
    var letterOnlyClass = getPreviewLetterOnlyClass(raw, previewMode, symbolOnly, sideClass);
    var lw100Dual1ZeileClass = getLw100Dual1ZeileClass(sideClass, previewMode);
    var lw100G02ZeilenDynamicClass = getLw100G02ZeilenDynamicClass(raw, previewMode);
    style = appendLw100G02ZeilenFontStyle(style, raw, previewMode);
    /* Die Seite steckt nur in der Klasse — D1 schluesselt danach, sonst
       schreibt der Regler nach front und gelesen wird back (lw108-Falle). */
    var adjSideKey = sideClass.indexOf('--back') !== -1 ? 'back' : 'front';
    var engravingHtml = buildEngravingHtml(raw, previewMode, g08MixedTextScale, adjSideKey);
    $layers.append(
      '<div class="lw041-preview-text' + modeClass + sideClass + fontBoostClass + g08MixedFontClass + symbolOnlyClass + letterOnlyClass + lw100Dual1ZeileClass + lw100G02ZeilenDynamicClass + getPreviewFontCodeClass() +
      '" data-lw041-preview-mode="' + previewMode + '" data-lw041-preview-line="' + lineNum + '" style="' + esc(style) + '">' +
      engravingHtml + '</div>'
    );
  }

  function buildEngravingHtml(raw, previewMode, g08MixedTextScale, adjSideKey) {
    if (!raw) return '';
    var html = '', re = /\(([^)]+)\)/g, last = 0, match;
    var wrapNextAsG03AfterMiniHerz = false;
    function appendTextSegment(text, afterG03MiniHerz) {
      if (!text) return;
      var chunk = esc(text);
      if (g08MixedTextScale) {
        chunk = '<span class="lw041-preview-g08-text-scale">' + chunk + '</span>';
      }
      if (afterG03MiniHerz) {
        chunk = '<span class="lw041-preview-g03-after-mini-herz">' + chunk + '</span>';
      }
      html += chunk;
    }
    while ((match = re.exec(raw)) !== null) {
      if (match.index > last) {
        appendTextSegment(raw.substring(last, match.index), false);
        wrapNextAsG03AfterMiniHerz = false;
      }
      var sym = getSymbolByName(match[1]);
      if (sym && sym.image) {
        var hasTextAfter = re.lastIndex < raw.length;
        var inlineBetween = match.index > 0 && hasTextAfter;
        var sandwichClass = isAs022G08SandwichIcon(previewMode, inlineBetween)
          ? ' lw041-preview-symbol--as022-g08-sandwich'
          : '';
        if (isAs022G03MiniHerzBetween(previewMode, inlineBetween, sym.text)) {
          sandwichClass += ' lw041-preview-symbol--as022-g03-mini-herz-between';
          wrapNextAsG03AfterMiniHerz = true;
        } else {
          wrapNextAsG03AfterMiniHerz = false;
        }
        /* G1/D1/D3 als Ueberlagerung: Einzelwert (ICON_ADJ) plus
           Gesamt-Schicht (TUNE.motivD*), Abstand aus D3. Neutral = alter Stil. */
        var iAdj = ((LW041_ICON_ADJ[adjSideKey || 'front'] || {})[previewMode] || {})[symbolSlug(sym.text)] || {};
        var iconTeile = '';
        if (previewMode !== 'nur_motiv') {
          iconTeile += 'margin-left:' + esc(lw041IconLuft(match[1], previewMode, getGlobalFont().font_name || 'G02')) + ';';
        }
        var iDx = (iAdj.dx || 0) + LW041_TUNE.motivDx;
        var iDy = (iAdj.dy || 0) + LW041_TUNE.motivDy;
        if (iDx || iDy) iconTeile += 'translate:' + iDx + 'em ' + iDy + 'em;';
        if (iAdj.scale != null && iAdj.scale !== 1) iconTeile += 'scale:' + iAdj.scale + ';';
        var gapStyle = iconTeile ? ' style="' + iconTeile + '"' : '';
        html += '<img class="lw041-preview-symbol lw041-preview-symbol--' + esc(symbolSlug(sym.text)) +
          sandwichClass + '"' + gapStyle +
          ' src="' + esc(sym.image) + '" alt="' + esc(match[1]) + '">';
      } else {
        html += esc('(' + match[1] + ')');
        wrapNextAsG03AfterMiniHerz = false;
      }
      last = re.lastIndex;
    }
    if (last < raw.length) appendTextSegment(raw.substring(last), wrapNextAsG03AfterMiniHerz);
    return html;
  }

  function ensurePreviewShell() {
    var $host = $('.up-Fenster-p-personalization-1 .fenster-content-contentin');
    if (!$host.length) return;
    if (!$host.find('.lw041-preview-wrap').length) {
      var shellHtml =
        '<div class="lw041-preview-wrap">' +
          '<div class="lw041-preview-label">Vorschau</div>' +
          '<div class="lw041-preview-stage" data-lw041-preview-stage>' +
            /* NIE loading="lazy" (GOTCHAS 27): das Fenster faehrt von ausserhalb des
               Viewports herein — dort laedt der Browser ein lazy-Bild nicht, und er
               prueft es beim Hereinfahren auch nicht neu. Das Basisbild bliebe grau,
               ohne Fehler in der Konsole (complete=false, naturalWidth 0). Real
               gemessen bei KS017, A203 und A227; Bestand am 2026-09-15 bereinigt. */
            '<img class="lw041-preview-base" alt="">' +
            '<div class="lw041-preview-layers"></div>' +
          '</div>' +
        '</div>';
      $host.prepend(shellHtml);
    }
    if (!$host.find('.lw041-global-font').length) {
      var $fontAnchor = $host.find('.lw041-preview-wrap');
      $fontAnchor.after(
        '<div class="lw041-global-font">' +
          '<div class="lw041-global-font-label">Schriftart</div>' +
          '<div class="lw041-font-grid" data-lw041-font-grid></div>' +
        '</div>'
      );
      renderFontGrid();
    }
  }

  /* [2] Jede Schriftzeile zeigt NUR ihren eigenen Code (G02 …), gerendert in
     ihrer eigenen Schrift. Frueher stand hier das Schriftmuster-Bild aus dem
     Theme-JSON — ein Bild kann nicht zeigen, wie DIESE Schrift heisst, und
     die Kundin sah in jeder Zeile dasselbe Wort. Das graue Code-Label bleibt
     im Baum (CSS blendet es aus), damit nichts davon abhaengt. */
  function fontGridHtml() {
    var fonts = getSelectableFonts();
    var current = getGlobalFont();
    var html = '';
    for (var i = 0; i < fonts.length; i++) {
      var f = fonts[i];
      var gname = String(f.font_name || '');
      var active = gname === current.font_name ? ' is-active' : '';
      html += '<button type="button" class="lw041-font-zeile' + active + '"' +
        ' data-value="' + esc(gname) + '" data-font="' + esc(gname) + '" data-family="' + esc(f.text) + '">' +
        '<span class="lw041-font-probe" style="font-family:' + esc(f.text) + ';">' + esc(gname) + '</span>' +
        '<span class="lw041-font-code">' + esc(gname) + '</span>' +
      '</button>';
    }
    return html;
  }

  function renderFontGrid() {
    $('[data-lw041-font-grid]').html(fontGridHtml());
    lw041SyncPanelFontUI();
  }

  /* Kompakte Schriftzeile IM Panel — nur Stile mit Text zeigen sie. Reine
     Ansicht auf den (unsichtbaren) globalen Speicher: jede Wahl wird dorthin
     gespiegelt und von dort in ALLE Zeilen zurueckgeschrieben. */
  function buildPanelFontRow() {
    var font = getGlobalFont();
    var name = String(font.font_name || '');
    var fam = font.text ? 'font-family:' + esc(font.text) + ';' : '';
    return '<div class="lw041-panel-font">' +
      '<button type="button" class="lw041-panel-font-head" aria-expanded="false">' +
        '<span class="lw041-panel-font-title">Schriftart</span>' +
        '<span class="lw041-font-probe" style="' + fam + '">' + esc(name) + '</span>' +
        '<span class="lw041-font-code">' + esc(name) + '</span>' +
        '<span class="lw041-panel-font-chev" aria-hidden="true">&#9662;</span>' +
      '</button>' +
      '<div class="lw041-panel-font-hinweis">Eine Schrift f&uuml;r die ganze Kette &mdash; zum &Auml;ndern tippen.</div>' +
      '<div class="lw041-panel-font-body">' +
        '<div class="lw041-global-font-label">Schriftart w&auml;hlen</div>' +
        '<div class="lw041-font-grid" data-lw041-font-grid></div>' +
      '</div>' +
    '</div>';
  }

  /* Jede Probe zeigt ihren EIGENEN data-value; nur die Kopfzeile zeigt die
     aktive Schrift. Nirgends die Eingabe der Kundin. */
  function lw041SyncFontProbe() {
    var aktiv = String(getGlobalFont().font_name || '');
    $('.product-info--lw041 .lw041-font-probe').each(function() {
      var $zeile = $(this).closest('.lw041-font-zeile');
      var name = $zeile.length ? String($zeile.attr('data-value') || '') : aktiv;
      if (name && $(this).text() !== name) $(this).text(name);
    });
  }

  /* Rollen neu vergeben: die ERSTE Schriftzeile in Dokumentreihenfolge darf
     waehlen, jede weitere ist Spiegel und startet zugeklappt (--zu). */
  function lw041SyncPanelFontUI() {
    var font = getGlobalFont();
    var name = String(font.font_name || '');
    $('.product-info--lw041 .lw041-font-grid button').each(function() {
      $(this).toggleClass('is-active', String($(this).attr('data-value') || '') === name);
    });
    $('.up-Fenster-p-personalization-1 .lw041-panel-font').each(function(i) {
      var $pf = $(this);
      var wurdeSpiegel = i > 0 && !$pf.hasClass('lw041-panel-font--spiegel');
      $pf.toggleClass('lw041-panel-font--spiegel', i > 0);
      if (wurdeSpiegel) $pf.addClass('lw041-panel-font--zu');
      if (i === 0) $pf.removeClass('lw041-panel-font--zu');
      if (i > 0 && $pf.hasClass('is-open')) {
        $pf.removeClass('is-open').find('.lw041-panel-font-head').attr('aria-expanded', 'false');
      }
      var $probe = $pf.find('.lw041-panel-font-head .lw041-font-probe').first();
      if ($probe.length) {
        $probe.text(name);
        if (font.text) $probe.css('font-family', font.text);
      }
      $pf.find('.lw041-panel-font-head .lw041-font-code').text(name);
    });
    lw041SyncFontProbe();
  }

  function buildSymbolGrid(sideIndex, lineNum) {
    var symbols = loadSymbols();
    var selected = getLineSymbol(sideIndex, lineNum);
    var html = '<div class="lw041-symbol-grid" data-side="' + sideIndex + '" data-line="' + lineNum + '">';
    for (var i = 0; i < symbols.length; i++) {
      var sym = symbols[i];
      var activeAttr = sym.text === selected ? ' class="is-active"' : '';
      html += '<button type="button"' + activeAttr + ' data-symbol="' + esc(sym.text) + '">' +
        '<img src="' + esc(sym.image) + '" alt="' + esc(sym.text) + '" loading="lazy">' +
        '<span class="lw041-symbol-label">' + esc(sym.text) + '</span></button>';
    }
    return html + '</div>';
  }

  /* ohneRaster: die Art „Text oben, Motiv unten" hat EIN eigenes Motivraster
     unter dem Feld (Zeile 2). Das Feld darf dann kein zweites mitbringen —
     sonst stuenden zwei Raster untereinander und das Motiv landete je nach
     Raster in einem anderen Speicher. */
  function buildLineField(sideIndex, lineNum, label, ohneRaster) {
    var maxLen = getLineMaxLen(lineNum, sideIndex);
    return '<div class="lw041-line-block" data-line-block="' + lineNum + '">' +
      '<div class="lw041-line-label">' + esc(label) + '</div>' +
      '<div class="lw041-line-input-wrap">' +
        '<input type="text" class="lw041-line-input" data-side="' + sideIndex + '" data-line="' + lineNum + '" data-max="' + maxLen + '">' +
        '<div class="lw041-line-clear" style="display:none"></div>' +
        '<span class="lw041-line-counter"><span class="lw041-count">0</span> / ' + maxLen + '</span>' +
      '</div>' +
      (ohneRaster ? '' : buildSymbolGrid(sideIndex, lineNum)) +
    '</div>';
  }

  /* [1]/[9] Stilkarte nach KE033/LW043 (Yin 2026-08-18): das ECHTE
     Engel-Liniendbild aus den Shopify Files plus eine Gravur-Ebene darueber —
     kein handgezeichneter Umriss. Es ist derselbe Anhaenger wie auf LW043,
     nur ohne Geburtsstein, also dieselbe Datei; nichts neu hochzuladen.
     Positionen in % der (quadratischen) Ikonenbox, Groessen in cqw
     (% der Ikonenbreite) — Werte 1:1 aus LW043, dort mit
     docs/lw043-angel-text-tuner.html eingestellt. */
  var LW041_ANGEL_ICON = window.VIV_LW041.bild_lw043_engel_icon_png;
  var LW041_CARD_POS = {
    /* 2026-08-18, Yin am Bild mit roter Linie: Text zu weit oben (am Hals
       statt am Rumpf) und zu klein — Position um +8 nach unten, Schrift um
       das von ihr genannte +20% (Faktor 1.2). */
    '1_zeile':   { x: 50,   y: 58,   size: 7.2 },
    '2_zeilen':  { x: 50.5, y: 60,   size: 7.8, gap: 7.2 },
    'nur_motiv': { x: 50,   y: 54,   size: 12.5 }
  };
  /* Vierte Karte. ⚠️ NICHT die Rohwerte von A221/LW100 uebernehmen: LW100
     zeichnet ein ANDERES Icon (lw100-engel-icon.png, Koerper deutlich hoeher —
     dort sitzt schon „1 Zeile" auf y 38.5 statt auf 50). Uebernommen sind
     darum die VERHAELTNISSE von LW100 (TM gegen 2 Zeilen: y −2, Groesse ×0.92,
     Abstand ×1.23, Motiv ×0.59 der Nur-Motiv-Groesse), angewendet auf die hier
     gueltigen 2-Zeilen-Werte. Das ist eine Herleitung, keine Messung — beim
     naechsten Blick aufs Bild nachziehen. */
  LW041_CARD_POS[LW041_TM_LAYOUT] = { x: 50.5, y: 58.5, size: 7.2, gap: 9, iconSize: 7.5 };

  function buildLayoutIcon(key) {
    var p = LW041_CARD_POS[key] || LW041_CARD_POS['1_zeile'];
    var pos = 'left:' + p.x + '%;top:' + p.y + '%;';
    var ovl = '';
    if (key === 'nur_motiv') {
      var sym = getSymbolByName('Mini Herz');
      var url = sym && sym.image ? sym.image : '';
      if (url) {
        ovl = '<span class="lw041-layout-ovl" style="' + pos + '">' +
          '<img src="' + esc(url) + '" alt="" style="width:' + p.size + 'cqw">' +
        '</span>';
      }
    } else if (key === '2_zeilen') {
      ovl = '<span class="lw041-layout-ovl" style="' + pos + 'font-size:' + p.size + 'cqw">' +
        'Emma<span class="lw041-layout-l2" style="margin-top:' + (p.gap - p.size) + 'cqw">2024</span>' +
      '</span>';
    } else if (key === LW041_TM_LAYOUT) {
      var symTm = getSymbolByName('Mini Herz');
      var urlTm = symTm && symTm.image ? symTm.image : '';
      ovl = '<span class="lw041-layout-ovl" style="' + pos + 'font-size:' + p.size + 'cqw">Emma' +
        (urlTm ? '<span class="lw041-layout-l2" style="margin-top:' + (p.gap - p.size) + 'cqw">' +
          '<img src="' + esc(urlTm) + '" alt="" style="width:' + p.iconSize + 'cqw;margin:0 auto">' +
        '</span>' : '') +
      '</span>';
    } else {
      ovl = '<span class="lw041-layout-ovl" style="' + pos + 'font-size:' + p.size + 'cqw">Emma</span>';
    }
    return '<span class="lw041-layout-icon">' +
      '<img class="lw041-layout-base" src="' + esc(LW041_ANGEL_ICON) + '" alt="" loading="lazy">' +
      ovl +
    '</span>';
  }

  var LW041_LAYOUTS = [
    { key: '1_zeile',   label: '1 Zeile',   sub: 'z.B. ein Name' },
    { key: '2_zeilen',  label: '2 Zeilen',  sub: 'z.B. Name + Datum' },
    { key: 'nur_motiv', label: 'Nur Motiv', sub: 'nur ein Symbol' },
    /* Literal statt der Variablen LW041_TM_LAYOUT: scripts/tuner_audit.py
       liest die Vorlagenliste per Regex aus dem Quelltext und sieht nur
       direkt geschriebene Zeichenketten. Mit der Variablen zaehlte es
       3 Vorlagen, hielt LW041 fuer kombifrei und verlangte K1/K2 gar nicht
       erst — waehrend die Schwesterdatei LW043 schon auf dem Literal stand. */
    { key: 'text_oben_motiv_unten', label: 'Text oben, Motiv unten', sub: 'z.B. Name \u00fcber Herz' }
  ];

  function buildLayoutSwitch(aktiv) {
    /* Mehr als drei Stile: am Handy startet die Liste zugeklappt (erste Reihe
       sichtbar), der Rest hinter dem Aufklapp-Knopf. Bei genau drei Stilen
       bleibt die Liste offen — die Faltung waere reine Kulisse. Die
       Desktop-CSS ignoriert beide Klassen. */
    var faltbar = LW041_LAYOUTS.length > 3;
    var html = '<div class="lw041-layout-switch' + (faltbar ? ' is-collapsed' : '') + '">';
    for (var i = 0; i < LW041_LAYOUTS.length; i++) {
      var l = LW041_LAYOUTS[i];
      html += '<button type="button" class="' + (l.key === aktiv ? 'is-active' : '') +
        (!faltbar || i < 3 ? ' lw041-chip-visible' : '') + '" data-layout="' + l.key + '">' +
        buildLayoutIcon(l.key) +
        '<span class="lw041-layout-name">' + esc(l.label) + '</span>' +
        '<span class="lw041-layout-sub">' + esc(l.sub) + '</span>' +
      '</button>';
    }
    html += '</div>';
    if (faltbar) {
      html += '<button type="button" class="lw041-layout-more">Weitere Gravur-Arten (' +
        (LW041_LAYOUTS.length - 3) + ') &#9662;</button>';
    }
    return html;
  }

  /* Nach jeder Wahl: aktive Karte sichtbar halten und mit Nachbarn auf drei
     auffuellen. Sortiert wird per CSS (order:-1) — die DOM-Reihenfolge bleibt
     unangetastet, sonst wandern Karten unter den Fingern der Kundin weg. */
  function lw041SyncLayoutCollapse($scope) {
    ($scope && $scope.length ? $scope : $('.up-Fenster-p-personalization-1'))
      .find('.lw041-layout-switch').each(function() {
        var $row = $(this);
        var $more = $row.next('.lw041-layout-more');
        var $chips = $row.find('button[data-layout]');
        if (!$row.hasClass('is-collapsed')) {
          $chips.addClass('lw041-chip-visible');
          if ($more.length) $more.html('Weniger Gravur-Arten &#9652;');
          return;
        }
        var $aktiv = $chips.filter('.is-active');
        $chips.removeClass('lw041-chip-visible');
        $aktiv.addClass('lw041-chip-visible');
        $chips.not($aktiv).slice(0, $aktiv.length ? 2 : 3).addClass('lw041-chip-visible');
        if ($more.length) {
          $more.html('Weitere Gravur-Arten (' + ($chips.length - 3) + ') &#9662;');
        }
      });
  }

  function buildLayoutPanel(sideIndex, layout) {
    /* [2] Die Schriftzeile steht IM Panel und nur bei Stilen mit Text —
       „Nur Motiv" graviert keinen Buchstaben, da waere sie sinnlos. */
    var schrift = layout === 'nur_motiv' ? '' : buildPanelFontRow();
    if (layout === '1_zeile') {
      return '<div class="lw041-panel" data-panel="1_zeile">' + schrift + buildLineField(sideIndex, 1, '1. ZEILE', true) + '</div>';
    }
    if (layout === '2_zeilen') {
      // Kein Motivraster mehr an Zeile 1/2 (Yin 2026-08-18: „一行刻字 两行刻字的
      // 情况下是没有图标的" — Icon-Wahl gibt es nur bei „Nur Motiv" und
      // „Text oben, Motiv unten").
      return '<div class="lw041-panel" data-panel="2_zeilen">' + schrift +
        buildLineField(sideIndex, 1, '1. ZEILE', true) +
        buildLineField(sideIndex, 2, '2. ZEILE', true) +
      '</div>';
    }
    // TEXT OBEN, MOTIV UNTEN: Name im Feld der 1. Zeile (max. 8), darunter
    // genau EIN Motivraster. Es traegt data-line="2", damit das Motiv im
    // Symbolspeicher der zweiten Zeile landet und nicht mit einer im Text
    // getippten Motiv-Marke kollidiert.
    if (layout === LW041_TM_LAYOUT) {
      return '<div class="lw041-panel" data-panel="' + LW041_TM_LAYOUT + '">' + schrift +
        buildLineField(sideIndex, 1, 'TEXT OBEN', true) +
        '<div class="lw041-line-label" style="margin-top:16px">MOTIV UNTEN</div>' +
        buildSymbolGrid(sideIndex, 2) +
      '</div>';
    }
    return '<div class="lw041-panel" data-panel="nur_motiv">' +
      '<div class="lw041-line-label">Motiv</div>' +
      '<div class="lw041-line-input-wrap">' +
        '<input type="text" class="lw041-line-input lw041-motiv-display" data-side="' + sideIndex + '" data-line="1" readonly placeholder="Symbol wählen">' +
        '<div class="lw041-line-clear" style="display:none"></div>' +
      '</div>' +
      buildSymbolGrid(sideIndex, 1) +
    '</div>';
  }

  function updateLineCounter($input) {
    var lineNum = $input.attr('data-line');
    var idx = getSideIndexFromEl($input);
    var maxLen = getLineMaxLen(lineNum, idx);
    $input.attr('data-max', maxLen);
    var len;
    if (isUppercaseOnlyFont()) {
      len = weightedLength(getG08LineRaw($input, idx, lineNum));
    } else {
      var parsed = parseLineValue($input.val() || '');
      var sym = parsed.symbol || getLineSymbol(idx, lineNum);
      len = weightedLength(composeLine(parsed.text, sym));
    }
    $input.closest('.lw041-line-block').find('.lw041-count').text(len);
    $input.closest('.lw041-line-input-wrap').find('.lw041-line-counter').html('<span class="lw041-count">' + len + '</span> / ' + maxLen);
    toggleLineClear($input, $input.val());
  }

  function applyLineLimitsForFont() {
    $('.lw041-line-input:not([readonly])').each(function() {
      var $input = $(this);
      var idx = getSideIndexFromEl($input);
      var lineNum = $input.attr('data-line');
      var maxLen = getLineMaxLen(lineNum, idx);
      if (isUppercaseOnlyFont()) {
        setG08LineRaw($input, idx, lineNum, getG08LineRaw($input, idx, lineNum), maxLen);
        syncSymbolGridForLine(idx, lineNum);
        updateLineCounter($input);
        return;
      }
      var parsed = parseLineValue($input.val() || '');
      var symbol = parsed.symbol || getLineSymbol(idx, lineNum);
      var text = normalizeLineTextForFont(parsed.text);
      while (weightedLength(composeLine(text, symbol)) > maxLen && text.length) {
        text = text.slice(0, -1);
      }
      if (symbol && weightedLength(composeLine(text, symbol)) > maxLen) {
        symbol = '';
      }
      setLineSymbol(idx, lineNum, symbol);
      syncLineInputComposed($input, text, symbol);
      syncSymbolGridForLine(idx, lineNum);
      updateLineCounter($input);
    });
  }

  function syncSymbolGridForLine(sideIndex, lineNum) {
    var selected = getLineSymbol(sideIndex, lineNum);
    if (!selected && isUppercaseOnlyFont()) {
      var raw = normalizeG08RawLine(getLineInputVal(sideIndex, lineNum));
      if (!hasInlineSymbolTokens(raw)) {
        var trailing = raw.match(/\(([^)]+)\)$/);
        if (trailing && isValidSymbolToken(trailing[1])) {
          selected = normalizeStoredSymbol(trailing[1]);
        }
      }
    }
    var $grid = $('.product_info_main_' + sideIndex).find('.lw041-symbol-grid[data-line="' + lineNum + '"]');
    $grid.find('button').removeClass('is-active');
    if (selected) $grid.find('button[data-symbol="' + selected + '"]').addClass('is-active');
  }

  function setSideLayout(sideIndex, layout) {
    sideLayouts[sideIndex] = layout;
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    $side.attr('data-lw041-layout', layout);
    $side.find('.lw041-layout-switch button').removeClass('is-active');
    $side.find('.lw041-layout-switch button[data-layout="' + layout + '"]').addClass('is-active');
    $side.find('.lw041-dynamic').html(buildLayoutPanel(sideIndex, layout));
    lw041SyncLayoutCollapse($side);
    if (ensureAs022GlobalFontForLayout()) renderFontGrid();
    else if (isAs022Personalization) renderFontGrid();
    renderFontGrid();
    applyFontToInputs();
    $side.removeClass('has-error');
    $side.find('.lw041-side-error').hide();
    window.lw041UpdatePreview();
  }

  function setupSide(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    if (!$side.length) return;
    $side.find('.pattles-tab-header').hide();

    if (!$side.find('.lw041-layout-switch').length) {
      /* [3] Alles unterhalb der Kopfzeile steckt in .lw041-side-body — das
         Akkordeon klappt genau diesen einen Knoten zu, der Baum bleibt sonst
         unveraendert (Zaehler, Schriftzeilen und Vorschau laufen weiter). */
      $side.find('.pattles-message-header').after(
        '<div class="lw041-side-body">' +
          buildLayoutSwitch(sideLayouts[sideIndex] || '1_zeile') +
          '<div class="lw041-dynamic"></div>' +
          '<p class="lw041-side-error">Bitte fülle die Gravur für diese Seite aus.</p>' +
        '</div>'
      );
    }
    setSideLayout(sideIndex, sideLayouts[sideIndex] || '1_zeile');
  }

  function renderAllPreviewEngravings() {
    var $layers = $('[data-lw041-preview-stage] .lw041-preview-layers');
    $layers.empty();
    var zu = getActiveSideCount();

    for (var i = 0; i < zu; i++) {
      var d = getSideData(i);
      var previewMode = getPreviewMode(d);
      var physicalSide = getPhysicalSideIndex(i);
      var sideClass = physicalSide === 1 ? ' lw041-preview-text--back' : ' lw041-preview-text--front';

      if (d.layout === '2_zeilen') {
        var c1 = composeLine(d.line1, d.sym1);
        var c2 = composeLine(d.line2, d.sym2);
        if (!c1 && !c2) continue;
        if (c1 && c2) {
          appendPreviewLine($layers, sideClass, buildPreviewStyle(physicalSide, previewMode, 1, c1), c1, previewMode, 1);
          appendPreviewLine($layers, sideClass + ' lw041-preview-line2', buildPreviewStyle(physicalSide, previewMode, 2, c2), c2, previewMode, 2);
          continue;
        }
        if (c1) appendPreviewLine($layers, sideClass, buildPreviewStyle(physicalSide, previewMode, 1, c1), c1, previewMode, 1);
        else appendPreviewLine($layers, sideClass, buildPreviewStyle(physicalSide, previewMode, 1, c2), c2, previewMode, 1);
        continue;
      }

      if (d.layout === LW041_TM_LAYOUT) {
        // Zwei eigenstaendige Ebenen auf derselben Seite: Text oben, Motiv
        // darunter. Jede darf fehlen — die andere rueckt NICHT nach, sonst
        // wanderte die Gravur beim Tippen.
        if (d.line1) {
          appendPreviewLine($layers, sideClass, buildPreviewStyle(physicalSide, previewMode, 1, d.line1), d.line1, previewMode, 1);
        }
        if (d.sym2) {
          appendPreviewLine($layers, sideClass + ' lw041-preview-line2', buildPreviewStyle(physicalSide, previewMode, 2, composeLine('', d.sym2)), composeLine('', d.sym2), previewMode, 2);
        }
        continue;
      }

      var raw = d.layout === 'nur_motiv' ? composeLine('', d.symOnly) : composeLine(d.line1, d.sym1);
      appendPreviewLine($layers, sideClass, buildPreviewStyle(physicalSide, previewMode, 1, raw), raw, previewMode, 1);
    }
    scheduleFitPreviewTextWidths();
    $layers.find('.lw041-preview-text img').off('load.lw041Fit').on('load.lw041Fit', fitPreviewTextWidths);
    if ($layers.find('.lw041-preview-text img').filter(function() { return this.complete; }).length) {
      fitPreviewTextWidths();
    }
  }


  /* ---- Reglerfenster. Panel-Id endet auf -tuner, Griff traegt .kt-title:
     Ziehen und DE/中 kommen von den gemeinsamen Snippets. ---- */
  function lw041TunerEnabled() {
    return /lw041tuner=1/.test(window.location.search + window.location.hash);
  }

  function lw041TunerApply() {
    var b = document.querySelectorAll('[class*="preview-stage"], [class*="preview-layers"]');
    for (var i = 0; i < b.length; i++) {
      b[i].style.setProperty('--tuner-block-scale', LW041_TUNE.blockScale);
      b[i].style.setProperty('--tuner-motiv-scale', LW041_TUNE.motivScale);
    }
  }

  function lw041TunerSichtbar() {
    /* Bei zugeklapptem Fenster hat die Buehne Breite 0 — jedes Drehen waere
       wirkungslos. Dann zeigt das Panel einen Hinweis statt einer Reihe
       Schein-Regler (auf AS022 hat genau das einen Nachmittag gekostet). */
    var b = document.querySelector('[class*="lw041-preview-stage"]');
    if (!b) return false;
    var r = b.getBoundingClientRect();
    return r.width > 0 && r.height > 0
      && r.left < window.innerWidth && r.right > 0
      && r.top < window.innerHeight && r.bottom > 0;
  }

  function lw041AnzahlSeiten() {
    var dom = $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]').length;
    return dom > 0 ? dom : previewSideCount;
  }

  function lw041IconRegler(seite, modus, slug, feld, standard) {
    return { get: function () {
               var o = ((LW041_ICON_ADJ[seite] || {})[modus] || {})[slug];
               return o && o[feld] != null ? o[feld] : standard;
             },
             set: function (v) {
               var o = lw041Pfad(LW041_ICON_ADJ, seite, modus);
               if (!o[slug]) o[slug] = {};
               o[slug][feld] = v;
             } };
  }

  function lw041LuftRegler(font, slug) {
    return { get: function () { return (LW041_LUFT_ADJ[font] || {})[slug] || 0; },
             set: function (v) {
               if (!LW041_LUFT_ADJ[font]) LW041_LUFT_ADJ[font] = {};
               LW041_LUFT_ADJ[font][slug] = v;
             } };
  }

  function lw041StatischeItems() {
    var T = LW041_TUNE;
    var it = [
      { h: 'Gesamt' },
      { label: 'Gesamt: Block ↔ X %', step: 0.25, get: function() { return T.blockDx; }, set: function(v) { T.blockDx = v; } },
      { label: 'Gesamt: Block ↕ Y %', step: 0.25, get: function() { return T.blockDy; }, set: function(v) { T.blockDy = v; } },
      { label: 'Gesamt: Block-Größe ×', step: 0.02, get: function() { return T.blockScale; }, set: function(v) { T.blockScale = v; } },
      { label: 'Gesamt: Motive ↔ X %', step: 0.02, get: function() { return T.motivDx; }, set: function(v) { T.motivDx = v; } },
      { label: 'Gesamt: Motive ↕ Y %', step: 0.02, get: function() { return T.motivDy; }, set: function(v) { T.motivDy = v; } },
      { label: 'Gesamt: Motiv-Größe ×', step: 0.02, get: function() { return T.motivScale; }, set: function(v) { T.motivScale = v; } },
      { h: '2. Zeile' },
      { label: '2. Zeile ↔ X %', step: 0.25, get: function() { return T.zeile2.dx; }, set: function(v) { T.zeile2.dx = v; } },
      { label: '2. Zeile ↕ Y %', step: 0.25, get: function() { return T.zeile2.dy; }, set: function(v) { T.zeile2.dy = v; } },
      { h: 'Limit' },
      { label: 'Limit: Breite max %', step: 0.5,
        get: function() { return T.limitBreite; }, set: function(v) { T.limitBreite = v; } },
      { label: 'Limit: Breite Zeile 2 ×', step: 0.02,
        get: function() { return T.limitBreiteZeile2; }, set: function(v) { T.limitBreiteZeile2 = v; } },
      { h: 'Lage je Schriftart' }
    ];
    ['G02', 'G04', 'G05', 'G06'].forEach(function(code) {
      it.push({ label: 'Schrift ' + code + ': Text ↔ X %', step: 0.25,
        get: function() { return T.schrift[code].dx; }, set: function(v) { T.schrift[code].dx = v; } });
      it.push({ label: 'Schrift ' + code + ': Text ↕ Y %', step: 0.25,
        get: function() { return T.schrift[code].dy; }, set: function(v) { T.schrift[code].dy = v; } });
    });
    return it;
  }

  function lw041KontextItems() {
    if (!lw041TunerSichtbar()) {
      return [{ h: '„Jetzt personalisieren" öffnen — die Vorschau ist zugeklappt' }];
    }
    var items = [];
    var font = getGlobalFont().font_name || 'G02';
    function fontJetzt() { return getGlobalFont().font_name || 'G02'; }
    var st = LW041_TUNE.schrift[font];
    if (st) {
      items.push({ h: 'Schrift · ' + font });
      items.push({ label: 'Text-Größe (Font)', step: 0.02,
        get: function() { return st.scale != null ? st.scale : 1; },
        set: function(v) { st.scale = v; } });
    }
    var n = lw041AnzahlSeiten();
    var hatKombi = false;
    for (var k = 0; k < n; k++) {
      if (getSideLayout(k) === LW041_TM_LAYOUT) hatKombi = true;
    }
    if (hatKombi) {
      /* Namen ausgeschrieben, nicht zusammengebaut: tuner_audit.py liest die
         Reglernamen als Literale aus dem Quelltext. */
      items.push({ h: 'Kombi · ' + font + ' · Text oben, Motiv unten' });
      items.push({ label: 'Kombi: Text ↔ X %', step: 0.25,
        get: function() { return lw041Kombi(LW041_TM_LAYOUT, fontJetzt()).textDx || 0; },
        set: function(v) { lw041KombiSetzen(LW041_TM_LAYOUT, fontJetzt()).textDx = v; } });
      items.push({ label: 'Kombi: Text ↕ Y %', step: 0.25,
        get: function() { return lw041Kombi(LW041_TM_LAYOUT, fontJetzt()).textDy || 0; },
        set: function(v) { lw041KombiSetzen(LW041_TM_LAYOUT, fontJetzt()).textDy = v; } });
      items.push({ label: 'Kombi: Motiv ↔ X %', step: 0.25,
        get: function() { return lw041Kombi(LW041_TM_LAYOUT, fontJetzt()).motivDx || 0; },
        set: function(v) { lw041KombiSetzen(LW041_TM_LAYOUT, fontJetzt()).motivDx = v; } });
      items.push({ label: 'Kombi: Motiv ↕ Y %', step: 0.25,
        get: function() { return lw041Kombi(LW041_TM_LAYOUT, fontJetzt()).motivDy || 0; },
        set: function(v) { lw041KombiSetzen(LW041_TM_LAYOUT, fontJetzt()).motivDy = v; } });
      items.push({ label: 'Kombi: Motiv-Größe ×', step: 0.02,
        get: function() { var w = lw041Kombi(LW041_TM_LAYOUT, fontJetzt()).motivMult; return w == null ? 1 : w; },
        set: function(v) { lw041KombiSetzen(LW041_TM_LAYOUT, fontJetzt()).motivMult = v; } });
      items.push({ label: 'Kombi: Abstand (Font)', step: 0.1,
        get: function() { return lw041Kombi(LW041_TM_LAYOUT, fontJetzt()).gap || 0; },
        set: function(v) { lw041KombiSetzen(LW041_TM_LAYOUT, fontJetzt()).gap = v; } });
    }
    for (var i = 0; i < n; i++) {
      /* Physische Seite, nicht UI-Index (lw108-Falle). */
      var seite = getPhysicalSideIndex(i) === 1 ? 'back' : 'front';
      /* ★ Der Renderer schluesselt ICON_ADJ nach dem VORSCHAUMODUS, nicht nach
         dem Vorlagennamen. Bei drei Vorlagen sind beide gleich — bei
         „Text oben, Motiv unten" heisst die Vorlage text_oben_motiv_unten,
         der Modus aber text_motiv. Ohne diese Umschluesselung schriebe der
         Regler in ein Fach, das beim Zeichnen nie gelesen wird. */
      var vorlage = getSideLayout(i) || '1_zeile';
      var modus = vorlage === LW041_TM_LAYOUT ? 'text_motiv' : vorlage;
      for (var zeile = 1; zeile <= 2; zeile++) {
        var symName = getLineSymbol(i, zeile);
        if (!symName) continue;
        var slug = symbolSlug(symName);
        var ix = lw041IconRegler(seite, modus, slug, 'dx', 0),
            iy = lw041IconRegler(seite, modus, slug, 'dy', 0),
            ig = lw041IconRegler(seite, modus, slug, 'scale', 1),
            il = lw041LuftRegler(font, slug);
        items.push({ h: (seite === 'back' ? 'Rückseite' : 'Vorderseite') + ' · Motiv · ' + symName });
        items.push({ label: 'Motiv ↔ X %', step: 0.02, get: ix.get, set: ix.set });
        items.push({ label: 'Motiv ↕ Y %', step: 0.02, get: iy.get, set: iy.set });
        items.push({ label: 'Motiv-Größe', step: 0.05, get: ig.get, set: ig.set });
        items.push({ label: 'Abstand (Font×Motiv)', step: 0.02, get: il.get, set: il.set });
      }
    }
    return items;
  }

  function lw041KontextKey() {
    var teile = [lw041TunerSichtbar() ? 'offen' : 'zu', getGlobalFont().font_name || 'G02'];
    var n = lw041AnzahlSeiten();
    for (var i = 0; i < n; i++) {
      teile.push(getPhysicalSideIndex(i));
      teile.push(getSideLayout(i) || '');
      teile.push(getLineSymbol(i, 1) || '');
      teile.push(getLineSymbol(i, 2) || '');
    }
    return teile.join('|');
  }

  /* Panel aus der festen Vorlage (harte Regel 5). Vorher stand hier ein
     handgebautes Panel — Ziehen, DE/中 und die Fokus-sichere Aktualisierung
     haengen ohnehin an der gemeinsamen Vorlage, und ohne sie fehlte die
     Sichtbarkeitswache. Die Kombi-Semantik der Parallelsitzung (gap schiebt
     Text und Motiv symmetrisch) ist unveraendert uebernommen. */
  (window.VivTuner = window.VivTuner || { q: [], refresh: function () {}, register: function () {
    this.q.push(arguments); return { refresh: function () {} };
  } }).register('lw041', {
    titel: 'LW041 Tuner',
    statisch: lw041StatischeItems,
    kontext: lw041KontextItems,
    kontextKey: lw041KontextKey,
    update: function () { window.lw041UpdatePreview(); },
    exportiere: function () {
      return { TUNE: LW041_TUNE, KOMBI_BY_FONT: LW041_KOMBI_BY_FONT,
               ICON_ADJ: LW041_ICON_ADJ, LUFT_ADJ: LW041_LUFT_ADJ };
    }
  });

  window.lw041UpdatePreview = function() {
    lw041TunerApply();
    /* Ohne diese Zeile bleibt die Kontext-Ebene auf dem ersten Zustand
       stehen (A184-Falle). */
    if (window.VivTuner && window.VivTuner.refresh) VivTuner.refresh('lw041');
    ensurePreviewShell();
    var baseUrl = getColorPreviewUrl();
    var $stage = $('[data-lw041-preview-stage]');
    $stage.find('.lw041-preview-base').attr('src', baseUrl);
    renderAllPreviewEngravings();
  };

  function bindEvents() {
    var $popup = $('.up-Fenster-p-personalization-1');

    $popup.off('click.lw041Layout', '.lw041-layout-switch button').on('click.lw041Layout', '.lw041-layout-switch button', function() {
      var idx = getSideIndexFromEl($(this));
      if (isNaN(idx)) return;
      /* [1] Nach der Wahl faltet die Liste wieder zu (K530-Verhalten): die
         gewaehlte Karte rutscht per CSS-order nach vorn und bleibt sichtbar,
         die uebrigen verschwinden wieder hinter dem Knopf. Ohne das bliebe
         die aufgeklappte Liste am Handy stehen und schoebe die Eingabe
         weiter nach unten — genau das, was die Faltung verhindern soll. */
      $(this).closest('.lw041-layout-switch').addClass('is-collapsed');
      setSideLayout(idx, $(this).data('layout'));
    });

    $popup.off('click.lw041Font', '[data-lw041-font-grid] button').on('click.lw041Font', '[data-lw041-font-grid] button', function() {
      globalFont = { font_name: $(this).data('font'), text: $(this).data('family') };
      applyFontToInputs();
      applyLineLimitsForFont();
      /* Wahl in den globalen Speicher spiegeln und von dort in ALLE Zeilen
         zurueck — danach die Zeile wieder zuklappen (K530-Verhalten). */
      lw041SyncPanelFontUI();
      $(this).closest('.lw041-panel-font').removeClass('is-open')
        .find('.lw041-panel-font-head').attr('aria-expanded', 'false');
      window.lw041UpdatePreview();
    });

    /* [1] Aufklapp-Knopf unter den Stilkarten (nur am Handy sichtbar). */
    $popup.off('click.lw041More', '.lw041-layout-more').on('click.lw041More', '.lw041-layout-more', function() {
      $(this).prev('.lw041-layout-switch').toggleClass('is-collapsed');
      lw041SyncLayoutCollapse($(this).closest('[class*="product_info_main_"]'));
    });

    /* [2] Schriftzeile im Panel. Spiegel-Zeilen waehlen NICHT selbst:
       1. Tipp klappt den Hinweis auf, 2. Tipp springt zur waehlbaren Zeile. */
    $popup.off('click.lw041PanelFont', '.lw041-panel-font-head').on('click.lw041PanelFont', '.lw041-panel-font-head', function() {
      var $pf = $(this).closest('.lw041-panel-font');
      if ($pf.hasClass('lw041-panel-font--spiegel')) {
        if ($pf.hasClass('lw041-panel-font--zu')) {
          $pf.removeClass('lw041-panel-font--zu');
          return;
        }
        var $primary = $('.up-Fenster-p-personalization-1 .lw041-panel-font')
          .not('.lw041-panel-font--spiegel').first();
        if (!$primary.length) return;
        var $pSide = $primary.closest('[class*="product_info_main_"]');
        var treffer = String($pSide.attr('class') || '').match(/product_info_main_(\d+)/);
        if (treffer) lw041OpenSide(parseInt(treffer[1], 10), false);
        $primary.addClass('is-open').find('.lw041-panel-font-head').attr('aria-expanded', 'true');
        lw041ScrollSideIntoView($primary);
        return;
      }
      var offen = !$pf.hasClass('is-open');
      $pf.toggleClass('is-open', offen);
      $(this).attr('aria-expanded', offen ? 'true' : 'false');
    });

    // „zum Ändern tippen" auf dem Hinweistext selbst → gleicher Sprung
    $popup.off('click.lw041PanelFontHinweis', '.lw041-panel-font--spiegel .lw041-panel-font-hinweis')
      .on('click.lw041PanelFontHinweis', '.lw041-panel-font--spiegel .lw041-panel-font-hinweis', function() {
        $(this).closest('.lw041-panel-font').find('.lw041-panel-font-head').trigger('click');
      });

    $popup.off('input.lw041Line', '.lw041-line-input:not([readonly])').on('input.lw041Line', '.lw041-line-input:not([readonly])', function() {
      var $input = $(this);
      var idx = getSideIndexFromEl($input);
      var lineNum = $input.attr('data-line');
      var maxLen = getLineMaxLen(lineNum, idx);
      if (isUppercaseOnlyFont()) {
        setG08LineRaw($input, idx, lineNum, $input.val(), maxLen);
        syncSymbolGridForLine(idx, lineNum);
        updateLineCounter($input);
        window.lw041UpdatePreview();
        return;
      }
      var parsed = parseLineValue(($input.val() || '').replace(/[\r\n]/g, ''));
      setLineSymbol(idx, lineNum, parsed.symbol);
      var text = normalizeLineTextForFont(parsed.text);
      var symbol = parsed.symbol || getLineSymbol(idx, lineNum);
      while (weightedLength(composeLine(text, symbol)) > maxLen && text.length) {
        text = text.slice(0, -1);
      }
      syncLineInputComposed($input, text, symbol);
      syncSymbolGridForLine(idx, lineNum);
      updateLineCounter($input);
      window.lw041UpdatePreview();
    });

    $popup.off('click.lw041Symbol', '.lw041-symbol-grid button').on('click.lw041Symbol', '.lw041-symbol-grid button', function() {
      var $grid = $(this).closest('.lw041-symbol-grid');
      var idx = parseInt($grid.attr('data-side'), 10);
      var lineNum = $grid.attr('data-line');
      var symName = normalizeStoredSymbol($(this).data('symbol'));
      var layout = getSideLayout(idx);
      var maxLen = getLineMaxLen(lineNum, idx);

      if (layout === 'nur_motiv') {
        setLineSymbol(idx, 1, symName);
        syncSymbolGridForLine(idx, 1);
        var $display = $('.product_info_main_' + idx).find('.lw041-motiv-display');
        syncLineInputComposed($display, '', symName);
        window.lw041UpdatePreview();
        return;
      }

      if (layout === LW041_TM_LAYOUT) {
        // Kein Textfeld dahinter — das Motiv wird nur gespeichert. Nochmal auf
        // dasselbe tippen waehlt es ab, sonst kaeme man nie wieder auf „kein
        // Motiv" zurueck.
        var schonDa = getLineSymbol(idx, 2) === symName;
        setLineSymbol(idx, 2, schonDa ? '' : symName);
        syncSymbolGridForLine(idx, 2);
        window.lw041UpdatePreview();
        return;
      }

      var $input = $('.product_info_main_' + idx).find('.lw041-line-input[data-line="' + lineNum + '"]');
      if (isUppercaseOnlyFont()) {
        var g08Raw = getG08LineRaw($input, idx, lineNum);
        var g08Next = appendOrReplaceTrailingG08Symbol(g08Raw, symName);
        if (weightedLength(g08Next) > maxLen) return;
        setG08LineRaw($input, idx, lineNum, g08Next, maxLen);
        syncSymbolGridForLine(idx, lineNum);
        updateLineCounter($input);
        window.lw041UpdatePreview();
        return;
      }

      var parsed = parseLineValue($input.val() || '');
      if (weightedLength(composeLine(parsed.text, symName)) > maxLen) return;

      setLineSymbol(idx, lineNum, symName);
      syncLineInputComposed($input, parsed.text, symName);
      syncSymbolGridForLine(idx, lineNum);
      updateLineCounter($input);
      window.lw041UpdatePreview();
    });

    $popup.off('click.lw041Clear', '.lw041-line-clear').on('click.lw041Clear', '.lw041-line-clear', function() {
      var $input = $(this).siblings('.lw041-line-input');
      var idx = getSideIndexFromEl($input);
      var lineNum = $input.attr('data-line') || '1';
      setLineSymbol(idx, lineNum, '');
      $input.val('');
      toggleLineClear($input, '');
      syncSymbolGridForLine(idx, lineNum);
      if ($input.attr('data-max')) updateLineCounter($input);
      window.lw041UpdatePreview();
    });

    if (!window._lw041PreviewFitResize) {
      window._lw041PreviewFitResize = true;
      $(window).on('resize.lw041PreviewFit', fitPreviewTextWidths);
    }
  }


  /* =====================================================================
     FOKUS-Maschinerie (2026-08-18) — Vorbild K530, in der angepassten Form
     von LW100 (gleiche Vorlagen-Generation, gleiches Engel-Basisfoto).
     ===================================================================== */

  function lw041AlleSeiten() {
    return $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]');
  }

  function lw041SideEl(index) {
    return $('.up-Fenster-p-personalization-1 .product_info_main_' + index);
  }

  /* Der Scrollkasten ist der Fenster-WURZELknoten (position: fixed,
     overflow-y: auto) — NICHT .fenster-content-inner, die scrollt nie.
     Auf LW100 hat genau diese Verwechslung das Ausweichen tot gelegt und
     dazu gefuehrt, dass das Kleben dort wieder ausgebaut wurde. */
  function lw041ScrollEl() {
    return $('.up-Fenster-p-personalization-1').get(0);
  }

  /* Programmatische Spruenge duerfen nichts verstecken: 600 ms Sperre und die
     Vorschau vorher zurueckholen. Der Versatz zieht die angepinnte Vorschau
     ab, damit der Seitenkopf nicht dahinter verschwindet. */
  function lw041ScrollSideIntoView($side) {
    var scrollEl = lw041ScrollEl();
    if (!scrollEl || !$side || !$side.length) return;
    var versatz = 8;
    var $pv = $('.lw041-preview-wrap').first();
    if ($pv.length && $pv.css('position') === 'sticky') versatz += ($pv.outerHeight() || 0);
    var top = $side[0].getBoundingClientRect().top
      - scrollEl.getBoundingClientRect().top + scrollEl.scrollTop - versatz;
    scrollEl.scrollTop = Math.max(0, top);
  }

  /* [3] Seiten-Akkordeon: nur bei zwei Gravurflaechen, dann ist immer genau
     eine offen. Der Zustand ueberlebt den Neuaufbau des Fensters. */
  var lw041OffeneSeite = 0;

  function lw041EnsureChevron($side) {
    var $head = $side.children('.pattles-message-header');
    /* Der Titel-<span> bleibt das ERSTE Kind — getSideLabel liest ihn per
       .first(), das Chevron haengt dahinter. */
    if ($head.length && !$head.children('.lw041-side-chev').length) {
      $head.append('<span class="lw041-side-chev" aria-hidden="true">&#9662;</span>');
    }
  }

  function lw041OpenSide(index, scrollen) {
    var $sides = lw041AlleSeiten();
    if (!$sides.filter('.lw041-side--klappbar').length) return;
    lw041OffeneSeite = index;
    $sides.removeClass('is-side-open');
    var $ziel = lw041SideEl(index).addClass('is-side-open');
    if (scrollen) lw041ScrollSideIntoView($ziel);
  }

  function lw041ApplyAkkordeon(zu) {
    var $sides = lw041AlleSeiten();
    if (zu < 2) {
      /* Eine Flaeche: kein Akkordeon — die Klasse wegnehmen, damit die
         Zuklapp-Regeln nichts verstecken koennen. */
      $sides.removeClass('lw041-side--klappbar').addClass('is-side-open');
      return;
    }
    $sides.addClass('lw041-side--klappbar').each(function() { lw041EnsureChevron($(this)); });
    var ziel = (lw041OffeneSeite >= 0 && lw041OffeneSeite < zu) ? lw041OffeneSeite : 0;
    $sides.removeClass('is-side-open');
    lw041SideEl(ziel).addClass('is-side-open');
    lw041OffeneSeite = ziel;
  }

  function lw041BindAkkordeon() {
    var $popup = $('.up-Fenster-p-personalization-1');
    $popup.off('click.lw041Side', '.lw041-side--klappbar > .pattles-message-header')
      .on('click.lw041Side', '.lw041-side--klappbar > .pattles-message-header', function() {
        var $side = $(this).parent();
        if ($side.hasClass('is-side-open')) return;
        var treffer = String($side.attr('class') || '').match(/product_info_main_(\d+)/);
        if (!treffer) return;
        lw041OpenSide(parseInt(treffer[1], 10), true);
      });
  }

  /* [7] Vorschau-Streifen auf der Bestaetigungsseite: klont die live
     gerenderte Buehne. WICHTIG: beim Bestaetigen ist das Fenster zu, die
     Buehne also 0 px breit — darum vorher unsichtbar messbar machen
     (fixed, -9999px), alle Flaechen aufklappen, frisch rendern, klonen,
     alles zurueckdrehen.
     Die Kanten des Engels sind am Basisfoto gemessen (uebernommen aus
     LW100 — dasselbe Foto, dieselben Anker). */
  /* Am ECHTEN Foto gemessen (Yin 2026-08-18: "LW043_ENGEL_BOX ist照抄的
     ——对 lw043-preview 那张 PNG 实测"), nicht von LW041/LW100 uebernommen —
     die drei Vorlagen teilen zwar dieselben Gravur-Text-Anker (PREVIEW_1_ZEILE
     etc.), aber DREI VERSCHIEDENE Fotos mit unterschiedlichem Zuschnitt.
     Gemessen mit Pillow gegen lw041-preview-silver.png (die Datei, die diese Datei
     tatsaechlich lädt): Kette und Anhaenger sind EIN zusammenhaengendes
     Metallteil ohne Luecke, darum liefert reine Pixel-Schwellwertsuche links/
     rechts/unten eine echte Kante, oben aber nur "Fenstergrenze = Treffer"
     bis tief in den Rahmen hinein. Die Oese/Ring-Oberkante (LW041) bzw. die
     Herzanhaenger-Oberkante (LW043 — sie haengt hoeher als der Engel-Ring)
     ist deshalb visuell an einem Prozent-Gitter abgelesen, links/rechts/unten
     pixelgenau (Schwellwert < 210, stabil ueber 150-232). */
  var LW041_ENGEL_BOX = {
    top: 53, bottom: 88.5, rand: 3,
    front: { left: 15, right: 36 },
    back: { left: 65, right: 86 }
  };

  function lw041FillConfirmVorschau() {
    var $ziel = $('.message-confirm-item-2 .lw041-confirm-vorschau').last();
    if (!$ziel.length || $ziel.children().length) return;
    var $popup = $('.up-Fenster-p-personalization-1');
    if (!$popup.length) return;

    var altStyle = $popup.attr('style') || '';
    var $zu = lw041AlleSeiten().not('.is-side-open');
    $popup.css({ display: 'block', visibility: 'hidden', position: 'fixed', left: '-9999px', top: '0' });
    $zu.addClass('is-side-open');
    window.lw041UpdatePreview();

    var $stage = $('[data-lw041-preview-stage]').first();
    var sw = $stage.length ? $stage[0].offsetWidth : 0;
    var sh = $stage.length ? $stage[0].offsetHeight : 0;
    if (sw && sh) {
      /* Je gravierte Flaeche EINE Kachel. Beide Engel liegen auf DERSELBEN
         Buehne (ein Foto, zwei Gravur-Ebenen) — eine Doppelkachel zeigt jeden
         Engel nur halb so gross. Also dieselbe Buehne zweimal klonen: je
         Kachel die fremde Gravur-Ebene raus und nur das Fenster um den
         eigenen Engel zeigen. */
      var zweiFlaechen = getActiveSideCount() > 1 && !usesFrontOnlyPreviewBase();
      var flaechen = zweiFlaechen
        ? ['front', 'back']
        : [getPhysicalSideIndex(0) === 1 ? 'back' : 'front'];
      var GAP = 8, spalte = $ziel.width() || 320;
      var pro = Math.floor((spalte - GAP * (flaechen.length - 1)) / flaechen.length);
      var ZIEL_B = Math.max(64, Math.min(150, pro));

      flaechen.forEach(function(side) {
        var box = LW041_ENGEL_BOX[side] || LW041_ENGEL_BOX.front;
        var R = LW041_ENGEL_BOX.rand;
        var fx = Math.max(box.left - R, 0);
        var fy = Math.max(LW041_ENGEL_BOX.top - R, 0);
        var fw = Math.min(box.right + R, 100) - fx;
        var fh = Math.min(LW041_ENGEL_BOX.bottom + R, 100) - fy;

        var $klon = $stage.clone();
        if (zweiFlaechen) {
          var fremd = side === 'back' ? 'front' : 'back';
          $klon.find('.lw041-preview-text--' + fremd).remove();
        }

        var fensterPx = sw * fw / 100;
        var f = ZIEL_B / fensterPx;
        var $clip = $('<div class="lw041-cv-clip"></div>').css({
          width: ZIEL_B + 'px',
          height: Math.ceil(sh * fh / 100 * f) + 'px',
          overflow: 'hidden'
        });
        /* erst skalieren, dann in Buehnen-Pixeln verschieben: das translate
           rechnet in den Einheiten VOR der Skalierung. */
        var $scale = $('<div class="lw041-cv-scale"></div>').css({
          width: sw + 'px',
          transform: 'scale(' + f + ') translate(' + (-sw * fx / 100) + 'px,' + (-sh * fy / 100) + 'px)',
          'transform-origin': 'top left'
        });
        $scale.append($klon);
        $clip.append($scale);

        $ziel.append($('<div class="lw041-cv-item"></div>')
          .css('width', ZIEL_B + 'px')
          .append($clip)
          .append('<div class="lw041-cv-name">'
            + esc(side === 'back' ? 'Rückseite' : 'Vorderseite') + '</div>'));
      });
    }

    $zu.removeClass('is-side-open');
    $popup.attr('style', altStyle);
  }
  window.lw041FillConfirmVorschau = lw041FillConfirmVorschau;

  window.lw041EnhanceConfirmOptions = function() {
    /* laeuft im Event-File VOR dem Einhaengen von .message-confirm-item-2 —
       der Handler dort ist synchron, also reicht ein Tick Verzoegerung. */
    setTimeout(lw041FillConfirmVorschau, 0);
  };

  window.lw041ValidateBeforeOpen = function() {
    return true;
  };

  window.lw041AfterUpdateSize = function(zu) {
    var gravurConfig = getActiveGravurConfig();
    if (gravurConfig && gravurConfig.physicalSides) {
      setPhysicalSideMap(gravurConfig.physicalSides);
    } else {
      var parsedZu = parseInt(zu, 10) || 0;
      var defaultMap = [];
      for (var mapIndex = 0; mapIndex < parsedZu; mapIndex++) defaultMap.push(mapIndex);
      setPhysicalSideMap(defaultMap);
    }

    zu = parseInt(zu, 10) || 0;
    if (zu < 1) {
      return;
    }
    zu = Math.min(zu, 2);
    previewSideCount = zu;
    ensurePreviewShell();
    for (var i = 0; i < zu; i++) setupSide(i);
    ensureAs022GlobalFontForLayout();
    renderFontGrid();
    applyFontToInputs();
    bindEvents();
    lw041ApplyAkkordeon(zu);
    lw041BindAkkordeon();
    lw041SyncLayoutCollapse();
    window.lw041UpdatePreview();
  };

  window.lw041OnPopupOpen = function() {
    symbolsCache = null;
    fontsCache = null;
    if (window.lw041RefreshPopupSides) lw041RefreshPopupSides();
    ensurePreviewShell();
    previewSideCount = $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]').length || previewSideCount;
    if (window.lw041AfterUpdateSize) lw041AfterUpdateSize(previewSideCount);
    else { bindEvents(); window.lw041UpdatePreview(); }
  };

  window.lw041OnPopupClose = function() {
    $('.product-info--lw041 [class*="product_info_main_"]').removeClass('has-error');
  };

  /* [6] Fehler-Fokus: die Kundin wird zum ERSTEN Problem gebracht — nur
     dessen Flaeche wird aufgeklappt und angescrollt; die uebrigen tragen ein
     rotes „!" am zugeklappten Kopf und kommen beim naechsten Klick auf „In
     den Warenkorb" der Reihe nach dran. */
  window.lw041ValidateSides = function(zu) {
    zu = Math.min(Math.max(parseInt(zu, 10) || 1, 1), 2);
    var erstesProblem = -1;
    for (var i = 0; i < zu; i++) {
      var $side = lw041SideEl(i);
      $side.removeClass('has-error');
      $side.find('.lw041-side-error').hide();
      if (!sideHasContent(i)) {
        $side.addClass('has-error');
        $side.find('.lw041-side-error').show();
        if (erstesProblem < 0) erstesProblem = i;
      }
    }
    if (erstesProblem < 0) return true;
    lw041OpenSide(erstesProblem, true);
    alert('Bitte fülle die Gravur für jede Seite aus.');
    return false;
  };

  window.lw041AppendSideProperties = function(properies_arr, zu, popup_title) {
    var fontName = getGlobalFont().font_name;
    for (var i = 0; i < zu; i++) {
      var title = getSideLabel(i);
      if (popup_title) {
        var parts = String(popup_title).split(',');
        if (parts[i]) title = $.trim(parts[i]);
      }
      var d = getSideData(i);
      if (d.layout === 'nur_motiv' && d.symOnly) {
        properies_arr.push([title + ' Motiv', formatSymbolOrderValue(d.symOnly)]);
        continue;
      }
      if (d.layout === LW041_TM_LAYOUT) {
        // Getrennte Namen, damit die Werkstatt Text und Motiv nicht mit dem
        // reinen „Motiv" aus nur_motiv verwechselt. Wortlaut wie auf A221.
        if (d.line1) properies_arr.push([title + ' Text oben', d.line1]);
        if (d.sym2) properies_arr.push([title + ' Motiv unten', formatSymbolOrderValue(d.sym2)]);
        if (d.line1) properies_arr.push([title + ' Font', fontName]);
        continue;
      }
      if (d.layout === '2_zeilen') {
        var r1 = lineOrderRow(title, '1 ZEILEN', '1. Zeile Text + Motiv', d.line1, d.sym1, true);
        var r2 = lineOrderRow(title, '2 ZEILE', '2. Zeile Text + Motiv', d.line2, d.sym2, true);
        if (r1.value) properies_arr.push([r1.name, r1.value]);
        if (r2.value) properies_arr.push([r2.name, r2.value]);
        if (sideHasText(d)) properies_arr.push([title + ' Font', fontName]);
        continue;
      }
      var row1 = lineOrderRow(title, 'Text', 'Text + Motiv', d.line1, d.sym1, true);
      if (row1.value) {
        properies_arr.push([row1.name, row1.value]);
        if (sideHasText(d)) properies_arr.push([title + ' Font', fontName]);
      }
    }
  };

  window.lw041ConfirmHtml = function(zu, popup_title) {
    var html = '';
    var template = $('#form_message_option2').html() || $('#form_message_option').html();
    if (!template) return '';
    var fontName = getGlobalFont().font_name;

    for (var i = 0; i < zu; i++) {
      var title = getSideLabel(i);
      if (popup_title) {
        var parts = String(popup_title).split(',');
        if (parts[i]) title = $.trim(parts[i]);
      }
      var d = getSideData(i);
      if (d.layout === 'nur_motiv' && d.symOnly) {
        html += template.replaceAll('{option_name}', title + ' Motiv').replaceAll('{option_value}', normalizeStoredSymbol(d.symOnly));
        continue;
      }
      if (d.layout === LW041_TM_LAYOUT) {
        if (d.line1) html += template.replaceAll('{option_name}', title + ' Text oben').replaceAll('{option_value}', d.line1);
        if (d.sym2) html += template.replaceAll('{option_name}', title + ' Motiv unten').replaceAll('{option_value}', normalizeStoredSymbol(d.sym2));
        if (d.line1) html += template.replaceAll('{option_name}', title + ' Font').replaceAll('{option_value}', fontName);
        continue;
      }
      if (d.layout === '2_zeilen') {
        var c1 = lineOrderRow(title, '1 ZEILEN', '1. Zeile Text + Motiv', d.line1, d.sym1, false);
        var c2 = lineOrderRow(title, '2 ZEILE', '2. Zeile Text + Motiv', d.line2, d.sym2, false);
        if (c1.value) html += template.replaceAll('{option_name}', c1.name).replaceAll('{option_value}', c1.value);
        if (c2.value) html += template.replaceAll('{option_name}', c2.name).replaceAll('{option_value}', c2.value);
        if (sideHasText(d)) html += template.replaceAll('{option_name}', title + ' Font').replaceAll('{option_value}', fontName);
        continue;
      }
      var cRow = lineOrderRow(title, 'Text', 'Text + Motiv', d.line1, d.sym1, false);
      if (cRow.value) {
        html += template.replaceAll('{option_name}', cRow.name).replaceAll('{option_value}', cRow.value);
        if (sideHasText(d)) html += template.replaceAll('{option_name}', title + ' Font').replaceAll('{option_value}', fontName);
      }
    }
    /* [7] Platzhalter fuer den Vorschau-Streifen — befuellt wird er per
       DOM-Klon NACH dem Einhaengen der Bestaetigungsseite. */
    if (html) html = '<div class="lw041-confirm-vorschau" aria-hidden="true"></div>' + html;
    return html;
  };

  $(document).on('change.lw041Color', '[name="option1"]', function() {
    if ($('.up-Fenster-p-personalization-1').hasClass('open')) window.lw041UpdatePreview();
  });
  $(document).on('change.lw041GravurOption', '[name="option2"]', function() {
    window.lw041GravurConfig = null;
    window.lwGravurConfig = null;
    if ($('.up-Fenster-p-personalization-1').hasClass('open')) window.lw041UpdatePreview();
  });
})(jQuery);
